const translations = {
  //sidebar
  dashboard: "डॅशबोर्ड",
  roleManagement: "भूमिका व्यवस्थापन",
  userManagement: "वापरकर्ता व्यवस्थापन",
  subUserManagement: "उप-वापरकर्ता व्यवस्थापन",
  UserAndRoleManagement: "वापरकर्ता आणि भूमिका व्यवस्थापन",
  admin: "ॲडमिन",
  landManagement: "जमीन व्यवस्थापन",
  landMaster: "जमीन मास्टर",
  villageManagement: "गाव व्यवस्थापन",
  typeManagement: "प्रकार व्यवस्थापन",
  land: "जमीन",
  administration: "प्रशासन",
  ownerManagement: "मालक व्यवस्थापन",
  measurementList: "संयुक्त मापन यादी",
  projects: "प्रकल्प",
  projectmanagement: "प्रकल्प व्यवस्थापन",
  landholdingList: "भूधारकाची माहिती",
  praposal: "प्रस्ताव",
  acquisitionrecords: "भूधारकाची माहिती रेकॉर्ड",
  finalaward: "अंतिम निवाडा",
  Payment: "पेमेंट",
  KJP: "केजेपी",
  workManagement: "कार्य व्यवस्थापन",
  objectionList: "कलम 15 कार्यवाही",
  reports: "अहवाल",
  landAcquisitions: "जमीन अधिग्रहण व्यवस्थापन",
  informationSystem: "भूसंपादन प्रणाली",
  logout: "लॉगआउट करा",
  ProposalManagement: "भूसंपादन प्रस्ताव",
  Assign: "नियुक्त करा",
  DirectPurchase: "खरेदी विक्री तक्ता",
  ProposalPublicationPreliminaryNotification: "प्रारंभिक अधिसूचना",
  KabjaPauti: "कब्जा पावती",
  PAP: "प्रकल्पग्रस्त व्यक्ति",
  ProjectAffectedPerson: "प्रकल्पग्रस्त व्यक्ती",
  Punavarshan: "पुनर्वसन प्रमाणपत्र",
  SearchBar: "शोध पट्टी",
  Version: "आवृत्ती",
  PunavarshanManagement: "पुनर्वसन व्यवस्थापन",
  Role: "भूमिका",
  TotalArea_7_12:"एकूण क्षेत्र",
  DetailsOfLandToBeAcquire: "संपादनासाठी प्रस्तावित जमिनीचा तपशील",
  DetailsOfLandToBeAcquirePI: "प्रस्तावाचा तपशील",
  AddLandholdingAcquisition: "जमीनधारक संपादन जोडा",
  EditLandholdingAcquisition: "जमीनधारक संपादन संपादित करा",
  LandTypeManagement: "जमीन प्रकार व्यवस्थापन",
  PrivateObjection: "खाजगी हरकत",
  GeneralObjection: "सामान्य हरकत",
  CreateProject: "प्रकल्प तयार करा",
  EditProject: "प्रकल्प संपादित करा",
  Hearing: "सुनावणी",
  GeneralObjectionForm: "साधारण हरकत फॉर्म",
  PrivateObjectionForm: "खाजगी हरकत फॉर्म",
  MeasurementWiseObjectionForm: "मोजमापानुसार हरकत फॉर्म",
  JointMeasurementList: "संयुक्त मोजणी",
  JointMeasurementDetails: "संयुक्त मोजणी तपशील",
  MarketValueBail: "जमिनीचे बाजारमूल्य निश्चिती",
  levy: "हेक्टरी दर निश्चिती",
  MarketValue: "जमिनीचे बाजारमूल्य",
  AdvancePayment: "आगाऊ मोबदला वाटप",
  AcquisitionAreaToAcquirableArea: "भूसंपादनासाठी प्रस्तावित क्षेत्र",
  ReportLandAcquisition: "जमीन संपादन अहवाल",
  Section11: "प्रारंभिक अधिसूचना",
  Parishtisht1Notice: "परिशिष्ट 1",
  Anusuchi2: "परिशिष्ट 2",
  Anusuchi3: "परिशिष्ट 3",
  Anusuchi4: "परिशिष्ट 4",
  Anusuchi5: "परिशिष्ट 5",
  Parishtisht6Notice: "परिशिष्ट 6",
  Anusuchi7: "परिशिष्ट 7",
  CompensationAmount: "प्रपत्र-ई",
  Compensation: "प्रपत्र-ई",
  FinalReward: "अंतिम निवाडा",
  ConcernValuer: "संबंधित मूल्यांकनकर्ता",
  Proposal: "प्रस्ताव",
  AddProposal: "प्रस्ताव तयार करा",
  ViewProposal: "प्रस्ताव पहा",


  //Navbar
  Stage: "टप्पा",
  NavProposalNo: "भूसंपादन प्रस्ताव नाव",
  Bhusampadan: "भूसंपादन प्रकरण क्र.",
  Date: "तारीख",
  SelectLanguage: "भाषा निवडा",
  Profile: "प्रोफाइल",
  Settings: "सेटिंग्ज",
  SignOut: "बाहेर पडा",
  SigningOut: "बाहेर पडत आहे...",
  completedProposals: "पूर्ण झालेले निवाडे",

  //AcquisitionRecords.js
  landRecordsData: "अनुसूची - एक",
  landSerialNo: "अ.क्र.",
  landGatNo: "गट क्र.",
  landArea: "जमिनीचे क्षेत्र",
  Actions: "क्रिया",
  editRecord: "रेकॉर्ड संपादित करा",
  saveRecord: "बदल जतन करा",
  cancelRecord: "रद्द करा",
  updateMessage: "रेकॉर्ड यशस्वीरित्या अपडेट केला.",
  TotalSurveyGat: "एकूण सर्व्हे / गट",
  ScheduleOnePreview: "अनुसूची - एक पूर्वदर्शन",


  SelectDistrict: "जिल्हा निवडा",
  SelectTaluka: "तालुका निवडा",
  SelectVillage: "गाव निवडा",
  LoadingDistricts: "जिल्हे लोड करत आहे",
  LoadingTalukas: "तालुके लोड करत आहे",
  LoadingVillages: "गावे लोड करत आहे",
  LoadingLandRecords: "भूसंपत्ती नोंदी लोड होत आहेत",
  DownloadReport: "अहवाल डाउनलोड करा",
  SendToCollector: " मा.जिल्हाधिकाऱ्यांना पाठवा",
  SendToProjectIncharge: "यंत्रणाला पाठवा",
  Checking: "तपासणी चालू आहे...",
  SrNo: "अनु क्र.",
  Area: "क्षेत्र",
  TotalHoldings: "एकूण होल्डिंग्ज",
  TotalArea: "एकूण क्षेत्र",
  IrrigativeArea: "सिंचन क्षेत्र",
  AcquisitionArea: "संपादन क्षेत्र",
  ProposeLAOOfficer: "भूसंपादन अधिकारी सुचवा",
  SelectLAOOfficer: "भूसंपादन अधिकारी निवडा",
  LoadingLAOUsers: "भूसंपादन अधिकारी वापरकर्ते लोड करत आहे...",
  SelectCollector: "कलेक्टर निवडा",
  LoadingUsers: "वापरकर्ते लोड करत आहे...",
  SelectCollectorUser: "कलेक्टर वापरकर्ता निवडा",
  SelectSamanvayOfficer: "समन्वय अधिकारी निवडा",
  Remarks: "शेरा",
  UploadDocument: "दस्तऐवज अपलोड करा *",
  Selected: "निवडलेले",
  View: "पहा",
  Cancel: "रद्द करा",
  DocumentPreview: "दस्तऐवज पूर्वदृश्य",
  SendToSamanvayOfficer: "समन्वय अधिकाऱ्यांना पाठवा",
  Assigning: "नियुक्त करत आहे...",
  AssignLAOOfficer: "भूसंपादन अधिकारी नियुक्त करा",
  FilterByLocation: "स्थानानुसार फिल्टर करा",
  AllRecords: "सर्व नोंदी",
  SelectLocation: "स्थान निवडा",
  PleaseSelectAll: "भू-संपत्ती नोंदी पाहण्यासाठी जिल्हा, तालुका आणि गाव निवडा",
  ShowingDataFor: "साठी डेटा दर्शवित आहे",
  NoLandRecordsForProject: "निवडलेल्या स्थानासाठी प्रकल्पात कोणत्याही भू-संपत्ती नोंदी उपलब्ध नाहीत:",
  TryAnother: "कृपया वेगळे स्थान निवडा किंवा डॅशबोर्डवरून प्रकल्प बदला.",
  NoLandRecords: "निवडलेल्या स्थानासाठी कोणत्याही भू-संपत्ती नोंदी उपलब्ध नाहीत.",
  LocationSelectionRequired: "स्थान निवड आवश्यक आहे",
  PleaseSelectFromFilter: "भू-संपत्ती नोंदी पाहण्यासाठी वरील फिल्टर पॅनलमधून जिल्हा, तालुका आणि गाव निवडा.",
  NoRecordsFound: "नोंदी आढळल्या नाहीत",
  Column: "स्तंभ",
  Assigned: "नियुक्त",
  selectFormat: "प्रारूप निवडा",
  pdfFormat: "PDF प्रारूप",
  pdfNote: "प्रिंटसाठी",
  csvFormat: "CSV प्रारूप",
  csvNote: "Excel मध्ये उघडण्यासाठी",
  success: "यशस्वी",
  Download: "डाउनलोड",
  Confirm: "पुष्टी करा",
  confirmResubmission: "पुन्हा सबमिशनची पुष्टी करा",
  resubmissionWarning: "आपण हा प्रस्ताव आधीच पाठवला आहे. आपण तो पुन्हा पाठवू इच्छिता का?",
  Sending: "पाठवत आहे",

  //AddLandholdingList
  addNewLandholding: "नवीन जमीन जोडा",
  heading: "नवीन जमीन मालकीच्या नोंदीबद्दल माहिती प्रविष्ट करा.",
  landholderName: "भूधारकाचे नाव",
  DistrictName: "जिल्हा",
  TAlukaName: "तालुका",
  VillageName: "गाव",
  SurveyNo: "सर्व्हे क्र.",
  AddSurveyGatNo: "गट/सर्व्हे क्रमांक",
  IrrigableArea: "लागवड योग्य क्षेत्र ",
  NonIrrigableArea: "पोट खराब क्षेत्र",
  AcquiredArea: "संपादित क्षेत्र",
  Status: "स्थिती",
  Active: "सक्रिय",
  inactive: "निष्क्रिय",
  EnterName: "नाव प्रविष्ट करा",
  EnterCultivableArea: "कृषियोग्य क्षेत्र प्रविष्ट करा",
  EnterNonCultivableArea: "अकृषियोग्य क्षेत्र प्रविष्ट करा",
  SelectLandholdingType: "भूधारक प्रकार निवडा",
  North: "उत्तर",
  EnterNorth: "दिशा प्रविष्ट करा",
  East: "पूर्व",
  EnterEast: "दिशा प्रविष्ट करा",
  West: "पश्चिम",
  EnterWest: "दिशा प्रविष्ट करा",
  South: "दक्षिण",
  EnterSouth: "दिशा प्रविष्ट करा",
  EnterTotalArea: "एकूण क्षेत्र प्रविष्ट करा",
  EnterAcquiredArea: "अधिग्रहित क्षेत्र प्रविष्ट करा",
  EnterSurveyNo: "सर्व्हे  क्रमांक प्रविष्ट करा",
  EnterIrrigableeArea: "लागवड योग्य क्षेत्र प्रविष्ट करा",
  EnterNonIrrigableArea: "पोट खराब क्षेत्र प्रविष्ट करा",

  SurveyType: "सर्वेक्षण प्रकार",
  AreaUnit: "क्षेत्र एकक",
  SelectAreaUnit: "क्षेत्र एकक निवडा",
  PleaseSelectAreaUnitFirst: "कृपया प्रथम क्षेत्रफळाचे एकक निवडा",
  Maximum: "कमाल",
  UseCommasToSeparateNames: "एकाहून अधिक नावे कॉमा वापरून विभक्त करा",
  Saving: "जतन करत आहे...",
  Save: "जतन करा",
  Add: "जोडा",
  Warning: "इशारा",
  Okay: "ठीक आहे",

  //AdminDashboard
  filter: "फिल्टर",
  AddNewProject: "प्रकल्प जोडा",
  totalProjects: "एकूण प्रकल्प",
  newProjectsThisMonth: "या महिन्यात ३ नवीन प्रकल्प",
  totalVillages: "एकूण गावे",
  updatedToday: "अद्यतन: आज",
  landOwners: "जमीनमालक",
  ownersAddedThisWeek: "या आठवड्यात ४५ जोडले",
  landType: "जमिनीचा प्रकार",
  landTypeExamples: "शेती, वन, औद्योगिक...",
  assignedWorks: "नेमलेले काम",
  inProgress: "प्रगतीपथावर",
  pendingNOCs: "प्रलंबित ना हरकत प्रमाणपत्र",
  awaitingDocuments: "५ कागदपत्रांची प्रतीक्षा",
  activeAdminUsers: "सक्रिय प्रशासक वापरकर्ते",
  lastLogin: "शेवटचा लॉगिन: १० मिनिटांपूर्वी",
  projectProgress: "प्रकल्प प्रगती",
  overallAcquisitionStatus: "एकूण संपादन स्थिती",
  growthVsLastMonth: "मागील महिन्याच्या तुलनेत वाढ",
  decreaseVsLastMonth: "मागील महिन्याच्या तुलनेत घट",
  stableVsLastMonth: "मागील महिन्यासारखीच स्थिती",

  recentProjectsActivities: "अलीकडील प्रकल्प क्रियाकलाप",
  ProjectId: "प्रकल्प आयडी",
  ProjectName: "प्रकल्प नाव",
  Description: "वर्णन",
  startDate: "प्रारंभ दिनांक",
  Progress: "प्रगती",
  action: "क्रिया",
  viewAll: "सर्व पहा",
  showingProjects: "२४ पैकी ५ प्रकल्प दर्शवत आहे",

  projectCompletionTrend: "प्रकल्प पूर्णत्व प्रवृत्ती",
  projectCompletionChart: "प्रकल्प पूर्णत्व चार्ट",
  last6Months: "गेल्या ६ महिने",
  lastyear: "गेल्या वर्षी",
  alltime: "सर्व वेळ",

  landTypeDistribution: "जमिनीच्या प्रकारांचे वितरण",
  landTypes: {
    agricultural: "शेती",
    urban: "शहरी",
    industrial: "औद्योगिक"
  },

  statuses: {
    active: "सक्रिय",
    onHold: "थांबवलेले"
  },

  actions: {
    edit: "संपादित करा",
    delete: "हटवा"
  },
  edit:"संपादित करा",

  allProjects: "सर्व प्रकल्प",
  activePeojects: "सक्रिय प्रकल्प",
  completedProjects: "पूर्ण झालेले प्रकल्प",

  ProposalChangeRequired: "प्रस्ताव बदल आवश्यक आहे",
  DifferentProposalDetected: "भिन्न प्रस्ताव आढळला",
  SwitchToDifferentProposal: "भिन्न प्रस्तावावर स्विच करायचे?",
  ProposalWarningMsg: "तुम्ही क्लिक केलेली ट्रॅकिंग आयटम सध्या निवडलेल्या प्रस्तावाशी संबंधित नाही.",
  CurrentProposal: "सध्याचा प्रस्ताव:",
  TargetProposal: "लक्ष्य प्रस्ताव:",
  WhatHappensOnProceed: "पुढे गेल्यावर काय होईल?",
  SwitchInfo: "तुमचा सक्रिय प्रस्ताव लक्ष्य प्रस्तावामध्ये बदलेल आणि तुम्हाला त्या टप्प्यावर नेले जाईल.",
  SwitchContinue: "स्विच करा आणि पुढे जा",
  Total: "एकूण",
  StageProgress: "टप्प्यांची प्रगती",
  CompletionRate: "पूर्णता दर",
  NoProjectData: "कोणतेही प्रकल्प डेटा उपलब्ध नाही",
  Project: "प्रकल्प",
  NoProgressData: "प्रगती डेटा उपलब्ध नाही",
  ProjectStages: "प्रकल्प टप्पे",
  Village: "गाव",
  Back: "मागे",
  ItemsPerPage: "प्रति पृष्ठ आयटम्स",
  Proposals: "प्रस्ताव",
  NavigateMsg: "आपल्या भूमिका परवानगीनुसार संबंधित टप्प्यावर नेण्यासाठी ओळ निवडा",
  TryAgain: "पुन्हा प्रयत्न करा",
  ProposalID: "प्रस्ताव आयडी",
  ProposalNo: "प्रस्ताव नाव",
  StageTransition: "टप्पा संक्रमण",
  DateTime: "दिनांक व वेळ",
  Action: "कार्यवाही",
  ProposalDate: "प्रस्ताव दिनांक",
  From: "पासून",
  To: "पर्यंत",
  Document: "दस्तऐवज",
  NoDocument: "दस्तऐवज नाही",
  ClickToViewTracking: "ट्रॅकिंग तपशील पाहण्यासाठी प्रस्तावावर क्लिक करा",
  Showing: "दाखवत आहे",
  Of: "पैकी",
  TotalProposals: "एकूण प्रस्ताव",
  Page: "पृष्ठ",
  Previous: "मागे",
  prev: "मागे",
  Next: "पुढे",
  GoToPage: "पृष्ठावर जा:",
  ShowingTracking: "प्रस्तावासाठी ट्रॅकिंग क्रियाकलाप दाखवत आहे",
  LandToBeAcquired: "संपादनासाठी जमीन",
  LandParcelsEntered: "नोंदवलेले भूखंड (सर्व्हे /गट क्रमांक)",
  JMR: "संयुक्त मोजणी अहवाल (JMR)",
  JMRCompleted: "पूर्ण JMR भूखंड",
  CompensationCompleted: "पूर्ण भरपाई भूखंड",
  FinalAward: "अंतिम निर्णय",
  FinalAwardCompleted: "पूर्ण अंतिम भूखंड",
  AdminSection11: "कलम ११",
  AdminSection12: "कलम १२",
  AdminSection15: "कलम १५",
  AdminSection19: "कलम १९",
  PaymentPossession: "कलम २१",
  AdminSection23: "कलम २३",
  AdminCompensation: "भरपाई",
  Adminkjp: "KJP",
  Other: "इतर",
  PaymentCompleted: "पूर्ण झालेली देयके",
  SelectProject: "प्रकल्प निवडा",
  ID: "आयडी",
  Type: "प्रकार",
  LoadingProjects: "प्रकल्प लोड होत आहेत...",
  Retry: "पुन्हा प्रयत्न करा",
  NoProjectsAvailable: "प्रकल्प उपलब्ध नाहीत",
  SelectProposalNo: "प्रस्ताव नाव निवडा (पर्यायी)",
  LoadingProposals: "प्रस्ताव लोड होत आहेत...",
  NoProposalsAvailable: "प्रस्ताव उपलब्ध नाहीत",
  ProceedWithProject: "फक्त प्रकल्पासह पुढे जाऊ शकता",
  NoProposalSelected: "प्रस्ताव निवडलेला नाही (फक्त प्रकल्पासह पुढे जा)",
  NoProposalsFound: "या प्रकल्पासाठी कोणतेही प्रस्ताव सापडले नाहीत",
  Updating: "अद्यतनित करत आहे...",
  Refresh: "रिफ्रेश करा",
  ChangeProject: "प्रकल्प बदला",
  Summary: "सारांश",
  DashboardSummary: "पूर्ण झालेले निवाडे",
  publicDocument: "सार्वजनिक दस्तऐवज पोर्टल",
  ViewDocument: "दस्तऐवज पहा",
  completedAward: "पूर्ण झालेले निवाडे",
  completedPortel: "भूसंपादन अभिलेख",
  Dashboard: "डॅशबोर्ड",
  ProposalTrend: "प्रस्तावाची प्रगती प्रवृत्ती",
  Loading: "लोड होत आहे...",
  ProposalProgress: "प्रस्ताव प्रगती",
  DocumentViewer: "दस्तऐवज दृश्य",
  OpenOriginal: "मूळ उघडा",
  ImageLoadFailed: "प्रतिमा लोड होऊ शकली नाही",
  PreviewNotAvailable: "पूर्वदृश्य उपलब्ध नाही",
  CannotPreview: "या प्रकारचा दस्तऐवज ब्राउझरमध्ये पाहता येणार नाही",
  DownloadOpen: "डाउनलोड करा व उघडा",

  recentProposalActivities: "अलीकडील प्रस्ताव क्रियाकलाप",
  acquireArea: "भूमी अधिग्रहण क्षेत्र",
  landOwner: "भूमिधारक",
  loadingProposalActivities: "अलीकडील प्रस्ताव क्रियाकलाप लोड होत आहेत...",
  loadingTrackingActivities: "प्रस्ताव ट्रॅकिंग क्रियाकलाप लोड होत आहेत...",
  changeProject: "प्रकल्प बदला",
  selectProject: "प्रकल्प निवडा",
  chooseProjectOptional: "भिन्न प्रकल्प निवडा (प्रस्ताव ऐच्छिक आहे)",
  chooseProjectContinue: "डॅशबोर्डवर जाण्यासाठी प्रकल्प निवडा (प्रस्ताव ऐच्छिक आहे)",
  continue: "पुढे जा",
  pspvp: "प्रगती पाहण्यासाठी कृपया एक प्रकल्प निवडा.",


  //CreateProject

  addProject: "प्रकल्प जोडा",
  addProjectDescription: "तपशीलवार माहिती असलेला नवीन प्रकल्प तयार करा आणि त्याला विशिष्ट राज्य आणि गावामध्ये असाइन करा.",

  BasicInformation: "मूलभूत माहिती",
  projectNamePlaceholder: "प्रकल्प नाव टाका",
  projectIdPlaceholder: "अद्वितीय प्रकल्प आयडी टाका",
  category: "श्रेणी",
  categoryPlaceholder: "श्रेणी निवडा",
  education: "शिक्षण",
  healthcare: "आरोग्यसेवा",
  infrastructure: "अवकाशरचना",
  water: "पाणी",
  energy: "ऊर्जा",
  projectManager: "प्रकल्प व्यवस्थापक",
  projectManagerPlaceholder: "प्रकल्प व्यवस्थापकाचे नाव टाका",
  projectDescription: "प्रकल्पाचे वर्णन",
  projectDescriptionPlaceholder: "तपशीलवार वर्णन टाका",
  tags: "टॅग्ज",
  tagsPlaceholder: "स्वल्पविरामाने विभक्त केलेले टॅग्ज टाका",

  timelineAndStatus: "कालावधी आणि स्थिती",
  endDate: "शेवटची तारीख",
  viewProgress: "प्रगती पाहा",
  priority: "प्राधान्य",

  pending: "प्रलंबित",
  planning: "योजना आखत आहे",
  onhold: "थांबवले आहे",
  cancelled: "रद्द केले",
  low: "कमी",
  medium: "मध्यम",
  high: "जास्त",
  urgent: "तातडीचे",
  state: "राज्य",
  statePlaceholder: "राज्य टाका",
  districtPlaceholder: "जिल्हा टाका",
  villageTown: "गाव / शहर",
  villageTownPlaceholder: "गाव किंवा शहर टाका",

  financialDetails: "आर्थिक तपशील",
  budget: "अंदाजित खर्च (₹)",
  budgetPlaceholder: "अंदाजित खर्चाची रक्कम टाका",
  stakeholdersPlaceholder: "हितधारक संस्था टाका",
  projectAdministration: "प्रकल्प प्रशासन",
  projectArea: "प्रकल्प क्षेत्र (वर्ग किमी)",
  projectAreaPlaceholder: "प्रकल्पाचे कव्हरेज क्षेत्र टाका",
  programBy: "कार्यक्रमद्वारे",
  programByPlaceholder: "अंमलबजावणी करणारी संस्था / विभाग टाका",
  sequenceOrder: "अनुक्रम / क्रमांक",
  sequenceOrderPlaceholder: "प्रकल्प यादीतील क्रम दर्शवतो",

  projectDocuments: "प्रकल्प दस्तऐवज",
  uploadFiles: "फाईल्स अपलोड करा",
  noFileSelected: "कोणतीही फाईल निवडलेली नाही",
  submitProject: "प्रकल्प सबमिट करा",
  EnterProjectName: "प्रकल्प नाव प्रविष्ट करा (उदा., मेट्रो विस्तार टप्पा 1)",
  ProjectType: "प्रकल्पाचा प्रकार",
  SelectProjectType: "प्रकल्पाचा प्रकार निवडा",
  ProjectDivision: "प्रकल्प विभाग",
  StateGovUT: "राज्य सरकार/केंद्रशासित प्रदेश",
  PublicWorksDivision: "सार्वजनिक बांधकाम विभाग",
  UrbanDevDivision: "शहरी विकास विभाग",
  RuralDevDivision: "ग्रामीण विकास विभाग",
  IndustrialDevDivision: "औद्योगिक विकास विभाग",
  ProjectIncharge: "प्रकल्प प्रमुख ",
  LoadingManagers: "उपलब्ध प्रकल्प व्यवस्थापक लोड करत आहे...",
  Creating: "निर्मिती करत आहे...",
  LoadingProjectManagers: "प्रकल्प व्यवस्थापक लोड होत आहेत...",
  SelectProjectIncharge: "प्रकल्प प्रभारी निवडा",
  SelectDivision: "विभाग निवडा",


  //EditLandholdinglist
  EditLandholding: "भूधाराकाची माहिती संपादित करा",
  irrigableArea: "लागवड योग्य क्षेत्र",
  nonIrrigableArea: "पोट खराब क्षेत्र",
  saveChanges: "बदल जतन करा",
  Loadinglandholdingdata: "जमीन धारण माहिती लोड होत आहे",
  WarningNolandIDavailableUpdatesmaynotworkproperly: "इशारा: कोणतीही जमीन आयडी उपलब्ध नाही. अद्यतने योग्य प्रकारे कार्य करणार नाहीत.",
  Reload: "पुन्हा लोड करा",
  SelectSurveyType: "सर्वेक्षण प्रकार निवडा",
  GatNo: "गट क्र.",
  PlotNo: "प्लॉट क्र.",
  GharNo: "घर क्र.",
  Loadingareaunits: "क्षेत्रफळ एकके लोड होत आहेत",
  Entertotalareain: "एकूण क्षेत्रफळ प्रविष्ट करा",
  Enteracquiredareain: "संपादन केलेले क्षेत्र प्रविष्ट करा",
  Enterirrigableareain: "लागवडयोग्य क्षेत्र प्रविष्ट करा",
  LandOccupants: "भूधारक",
  AddOccupant: "नवीन भूधारक जोडा",
  AllAreasDistributed: "सर्व क्षेत्र वितरित केले गेले आहेत",
  NoLandIdAvailable: "कोणतीही जमीन आयडी उपलब्ध नाही",
  AddNewOccupant: "नवीन धारक जोडा",
  TotalAreaDistributionSummary: "एकूण क्षेत्र सारांश",
  LandTotalArea: "जमिनीचे एकूण क्षेत्र",
  DistributedToOwners: "भूधारकाचे क्षेत्र",
  Remaining: "उर्वरित क्षेत्र",
  AllAreaDistributed: "संपूर्ण जमीन क्षेत्र धारकांमध्ये वितरित केले गेले आहे",
  AcquiredAreaDistributionSummary: "प्रस्तावित क्षेत्र सारांश",
  LandAcquiredArea: "प्रस्तावित जमीन क्षेत्र",
  DistributedAcquiredToOwners: "भूधारकाचे क्षेत्र",
  RemainingAcquired: "उर्वरित क्षेत्र",
  AddNewOccupantBtn: "नवीन धारक जोडा",
  OwnerName: "भूधारकाचे नाव",
  LimitedByRemainingAcquired: "उर्वरित अधिग्रहित क्षेत्राने मर्यादित",
  Max: "कमाल",
  OwnersTotal: "मालकाची एकूण",
  Adding: "जोडत आहे...",
  EditOccupant: "धारक संपादित करा",
  MaxAvailable: "कमाल उपलब्ध",
  LimitedByAvailableAcquired: "उपलब्ध अधिग्रहित क्षेत्राने मर्यादित",
  UpdateOccupant: "धारक अपडेट करा",
  ExistingOwners: "अस्तित्वात असलेले भूधारक",
  DeleteOccupant:"जमीन मालक हटवा",
  Number1: "क्रमांक",
  Edit: "संपादित करा",
  NoOwnersFound: "या जमीन धारकासाठी कोणतेही मालक सापडले नाहीत",



  //GeneralObjection
  formTitle: "सामान्य आक्षेप नोंदणी फॉर्म",
  formSubtitle: "आपले आक्षेप तपशील सबमिट करा",
  ObjectionInformation: "हरकतीची माहिती",
  objectionType: "हरकतीचा प्रकार",
  affectedSurveyNo: "बाधित सर्वेक्षण क्रमांक.",
  SupportingDocumentsReferences: "सहाय्यक कागदपत्रे आणि संदर्भ",
  objectorName: "अर्जदाराचे नाव",
  objectorAddress: "अर्जदाराचा पत्ता",
  contactNumber: "संपर्क क्रमांक",
  Entermobilenumber: "मोबाईल नंबर टाका",
  voter: "मतदान कार्ड",
  dl: "ड्रायव्हिंग लायसन्स",
  IdentityProof: "ओळख पुरावा",
  identityProofNumber: "ओळखपत्र क्रमांक",
  uploadProof: "ओळखपत्र अपलोड करा",
  affectedArea: "प्रभावित क्षेत्र",
  village: "गाव",
  taluka: "तालुका",
  objectionCategories: "आक्षेपाचे प्रकार",
  selectCategory: "श्रेणी निवडा",
  landAcquisition: "पुनर्भू",
  compensation: "भरपाई रक्कम",
  cropLoss: "पिकांचे नुकसान",
  treeLoss: "झाडांचे नुकसान",
  measurementIssue: "मोजमापातील अडचणी",
  assetAssessment: "मालमत्तेचे मूल्यांकन",
  treeOwnership: "झाडांच्या मालकीचे मुद्दे",
  others: "इतर",
  reset: "रीसेट करा",
  submit: "सबमिट करा",
  ownershipIssues: "हक्क/मालकीचे प्रश्न",
  livelihoodImpact: "उपजीविकेवर परिणाम",
  submissionsuccessful: "सबमिशन यशस्वी झाले!",
  yoh: "तुमचा आक्षेप यशस्वीरित्या सबमिट केला गेला आहे.",
  referencenumber: "संदर्भ क्रमांक",
  submissiondate: "सबमिशन तारीख",
  pkyr: "भविष्यातील चौकशीसाठी कृपया तुमचा संदर्भ क्रमांक जपून ठेवा.",
  sao: "दुसरा आक्षेप सबमिट करा",
  pctfe: "कृपया खालील चुका दुरुस्त करा.",
  maxsize: "कमाल आकार: २५६ केबी, स्वरूप: जेपीजी, पीएनजी, पीडीएफ",
  fileuploaded: "फाइल अपलोड झाली",
  KB: "KB",
  psalo: "कृपया किमान एक आक्षेप श्रेणी निवडा.",
  Processing: "प्रक्रिया करत आहे",


  //EditLandTypeMangement
  typeCode: "प्रकार कोड",

  //Hearing
  hearingManagement: "सुनावणी व्यवस्थापन",
  upcomingHearings: "आगामी सुनावण्या",
  ongoingHearings: "सध्याच्या सुनावण्या",
  completedHearings: "पूर्ण  सुनावण्या",

  dateOfHearing: "ऐकणीची तारीख",
  place: "ठिकाण",
  designatedTo: "नियुक्त केले",
  searchPlacePlaceholder: "ठिकाण शोधा (बुलढाणा जिल्हा)",
  designatedPersonPlaceholder: "या प्रकरणासाठी नेमलेली व्यक्ती प्रविष्ट करा",
  generateNotice: "सूचना तयार करा",
  share: "शेअर करा",
  dateLimitNote: "आजपासून 60 दिवसांपेक्षा अधिक असू शकत नाही",
  caseNumber: "भूसंपादन प्रकरण क्रमांक",
  assignedTo: "नेमलेले",
  Decision: "निर्णय",
  Scheduled: "नियोजित",
  update: "अद्यतन करा",

  CaseDetails: "प्रकरण तपशील",
  CaseInformation: "प्रकरण माहिती",
  CaseDetails1: "प्रकरण तपशील :",
  CaseIncharge: "प्रकरण प्रभारी :",
  Completed: "पूर्ण झाले",
  InFavor: "अनुकूल निर्णय",
  LandOwners: "जमीन मालक",
  HearingProgress: "सुनावणी प्रगती",
  AttachedDocuments: "संलग्न दस्तऐवज",
  ShareDetails: "तपशील शेअर करा",
  Close: "बंद करा",
  UpdateStatus: "स्थिती अपडेट करा",

  ShareHearingDetails: "सुनावणीचे तपशील सामायिक करा",
  Enteremailaddress: "ईमेल पत्ता प्रविष्ट करा",
  MobileNumber: "मोबाइल नं.",
  sendnotification: "सूचना पाठवा",

  // Section93
  Section93: "कलम ९३",

  //Landholdinglist
  landholdingDetail: "प्रस्ताव माहिती",
  LandholdingManagement: "जमीन मालकी व्यवस्थापन",
  AddLandholding: "नवीन भूधारक समाविष्ट करा",
  SearchPlaceholder: "जमीन क्रमांक किंवा जमीनधारकाच्या नावाने शोधा",
  LandNo: "जमीन क्र.",
  LandholdersName: "भूधारकाचे नाव (7/12 नुसार)",
  Delete: "हटवा",

  //LandTypeManagement
  Search: "शोधा",
  SearchProjects: "प्रकल्प शोधा",
  Add_New_Land_Type: "नवीन जमीन प्रकार जोडा",
  All: "सर्व",
  All_Types: "सर्व प्रकार",
  Agricultural: "शेती",
  NonAgricultural: "बिगर शेती",
  Forest: "वन",
  Government: "सरकारी",
  CODE: "कोड",
  NAME_EN_MR: "नाव (इंग्रजी/मराठी)",
  PROPERTIES: "गुणधर्म",
  Agricultural_Land: "कृषी भूमि",
  Used_for_farming_and_cultivation: "शेती आणि लागवडीसाठी वापरले जाते.",
  Forest_Land: "वन भूमि",
  Protected_forest_area_under_government_control: "सरकारी नियंत्रणाखाली संरक्षित वन क्षेत्र.",

  //MeasurementList
  Land_Management_System: "भूमि व्यवस्थापन प्रणाली",
  Collector_Buldhana: "जिल्हाधिकारी, बुलढाणा",
  Administrator: "प्रशासक",
  Land_Measurement_Records: "जमीन मोजणी नोंदी",
  Search_records: "नोंदी शोधा...",

  NO: "क्र.",
  ACTUAL_AREA_ERC: "प्रत्यक्ष क्षेत्र ई.आर.सी.",
  ACQUISITION_AREA_ER_PUBLIC: "संपादन क्षेत्र ई.आर. (सार्वजनिक)",
  OWNER_NAME_AS_PER_RECORD: "नोंदीनुसार भूधारकाचे नाव",
  GOVERNMENT_AREA_ERC: "सरकारी क्षेत्र ई.आर.सी.",
  REVISED_LAND_ACQUISITION: "सुधारित भूमि संपादन",
  PROJECT_LAND_SURVEY_AREA: "प्रकल्प भूमि सर्वेक्षण क्षेत्र",

  RECENT_AREA_ER: "अलीकडील क्षेत्र ई.आर.",
  SURVEY_NOTE_ER: "सर्वेक्षण टिप्पणी ई.आर.",
  SUITABL_AREA_ER: "उपयुक्त क्षेत्र ई.आर.",
  PROJECT_BENEFICIARY_NAME: "प्रकल्प लाभार्थी नाव",
  COMBINED_SURVEY_POINT: "संयुक्त सर्वेक्षण बिंदू",

  Pond_Plant: "तलाव/रोपण",
  House: "घर",
  Well_Motor: "विहीर/मोटर",
  Burial_Site: "दफन स्थळ",
  Trees: "झाडे",

  None: "नाही",
  Add_New_Measurement: "नवीन मोजणी जोडा",
  HideForm: "फॉर्म लपवा",
  cm: "सेमी",

  Add_New_Measurement_Details: "नवीन मोजणी तपशील जोडा",
  Actual_Area_ERC: "प्रत्यक्ष क्षेत्र ई.आर.सी.",
  Acquisition_Area: "संपादन क्षेत्र",
  Owner_Name: "भूधारकाचे नाव",
  Government_Area_as_per_Record: "नोंदीनुसार सरकारी क्षेत्र",
  Revised_Land_Acquisition_Area: "सुधारित भूमि संपादन क्षेत्र",
  Project_Land_Survey_Area: "प्रकल्प भूमि सर्वेक्षण क्षेत्र",
  Survey_Suitable_ER: "सर्वेक्षण उपयुक्त ई.आर.",
  Note_Area_ER: "नोंद क्षेत्र ई.आर.",
  Beneficiary_Name: "लाभार्थीचे नाव",
  Beneficiary_Area: "लाभार्थी क्षेत्र",

  //ObjectionList
  ScheduleHearing: "सुनावणीचे वेळापत्रक",
  Objection_Management_System: "आक्षेप व्यवस्थापन प्रणाली",
  All_Objections: "सर्व आक्षेप",
  General: "सामान्य",
  Private: "खाजगी",
  Search_objections: "आक्षेप शोधा...",
  Filter_Status: "स्थिती फिल्टर करा",
  FilterbyStatus: "स्थितीनुसार फिल्टर करा",
  Export_Data: "डेटा निर्यात करा",
  General_Objection: "सामान्य आक्षेप",
  Affected_Person_Objection: "प्रभावित व्यक्ती आक्षेप",
  Showing_3_of_7_objections: "७ पैकी ३ आक्षेप दाखवत आहे",
  Clear_all_filters: "सर्व फिल्टर साफ करा",
  OBJECTION_TYPE: "आक्षेप प्रकार",
  OBJECTOR: "आक्षेपकर्ता",
  Rejected: "नाकारले",
  Project_B: "प्रकल्प बी",
  Project_D: "प्रकल्प डी",
  AllStatuses: "सर्व स्थिती",
  // Rejected: "नाकारलेले",
  NOF: "कोणतेही आक्षेप आढळले नाहीत",
  TAYF: "तुमचे फिल्टर समायोजित करण्याचा प्रयत्न करा किंवा नवीन आक्षेप तयार करा.",

  //PrivateObjection
  AffectedPersonObjection: "प्रभावित व्यक्तीचा आक्षेप",
  Submityourprivateobjectiondetails: "तुमच्या खाजगी आक्षेपांची माहिती सबमिट करा.",
  OwnerInformation: "मालकाची माहिती",
  address: "पत्ता",
  uploadIdentityProof: "ओळखपत्र अपलोड करा",
  aadhaar: "आधार कार्ड",
  pan: "पॅन कार्ड",
  CASE_NO: "प्रकरण क्र",
  Representative: "प्रतिनिधी तपशील (लागू असल्यास)",
  representativeName: "प्रतिनिधीचे नाव",
  LandDetails: "जमिनीचा तपशील",
  agriculture: "शेती",
  accurateLandRecords: "अचूक जमीन नोंदी",
  assessmentIssue: "मूल्यांकन समस्या",
  cropsAssessment: "पिकांचे मूल्यांकन",
  titleOwnershipIssue: "हक्क/मालकी समस्या",
  nonAgriculture: "बिगर शेती",
  structureAssessment: "संरचना मूल्यांकन",
  waterBodies: "जलस्रोत",
  otherObjection: "इतर हरकती ",

  resetForm: "फॉर्म रीसेट करा",
  submitObjection: "हरकत सबमिट करा",

  //ProjectManagemen
  projectManagement: "प्रकल्प व्यवस्थापन",
  newProject: "नवीन प्रकल्प",
  advancedFilters: "प्रगत फिल्टर",
  filterProjects: "प्रकल्प फिल्टर करा",
  dateRange: "दिनांक श्रेणी",
  allManagers: "सर्व व्यवस्थापक",
  budgetRange: "अंदाजित खर्च श्रेणी",
  min: "किमान",
  max: "जास्तीत जास्त",
  applyFilters: "फिल्टर लागू करा",

  //Reports
  ReportManagementSystem: "अहवाल व्यवस्थापन प्रणाली",
  SelectReportType: "अहवाल प्रकार निवडा",
  ObjectionReport: "हरकत अहवाल",
  LandReport: "जमीन अहवाल",
  ProjectReport: "प्रकल्प अहवाल",
  DownloadList: "यादी डाउनलोड करा",
  SearchByNameProjectOrOfficer: "नाव, प्रकल्प किंवा अधिकारीद्वारे शोधा",
  ProjectStatus: "प्रकल्प स्थिती",
  HearingStatus: "ऐकणीची स्थिती",
  ObjectionType: "हरकतीचा प्रकार",
  ObjectorNames: "हरकत करणाऱ्याची नावे",
  DesignatedOfficer: "नियुक्त अधिकारी",
  ProjectNameOrID: "प्रकल्प नाव/आयडी",
  ViewDetails: "तपशील पहा",
  Resolved: "निराकरण केले",
  Ongoing: "चालू",
  Upcoming: "आगामी",
  AllTypes: "सर्व प्रकार",
  GenerateReport: "अहवाल तयार करा",
  GenerateDownload: "जनरेट करा आणि डाउनलोड करा",

  //VillageManagement
  VillageManagerTitle: "गाव व्यवस्थापक – बुलढाणा, महाराष्ट्र",
  TalukaName: "तालुका",
  PinCode: "पिन कोड",
  CensusCode: "जनगणना कोड ",
  Latitude: "अक्षांश",
  Longitude: "रेखांश",
  AddVillage: "गाव जोडा",
  NoVillages: "कोणतेही गावे जोडलेली नाहीत.",
  Maharastra: "महाराष्ट्र",
  Taluka: "तालुका",
  StateCode: "राज्य कोड",
  Pin: "पिन",
  Lat: "अक्षांश",
  Long: "रेखांश",
  Created: "तयार केले",
  Updated: "अद्यतनित",
  //UserProfile
  UserProfile: "वापरकर्ता प्रोफाईल",
  EditProfile: "प्रोफाईल संपादित करा",
  LoadProfileError: "प्रोफाईल डेटा लोड करण्यात अयशस्वी. कृपया नंतर पुन्हा प्रयत्न करा.",
  Online: "ऑनलाइन",
  PersonalInformation: "वैयक्तिक माहिती",
  FullName: "पूर्ण नाव",
  Mobile: "मोबाईल",
  LocationInformation: "स्थान माहिती",
  District: "जिल्हा",
  Tehsil: "तहसील",
  ProfessionalInformation: "व्यावसायिक माहिती",
  Designation: "पदनाम",
  Department: "विभाग",


  //EditLandTypeManagement
  EditLandType: "भूमी प्रकार संपादन करा",
  TypeCode: "प्रकार कोड",
  NameEnglish: "नाव (इंग्रजी)",
  NameMarathi: "नाव (मराठी)",
  DescriptionEnglish: "वर्णन (इंग्रजी)",
  DescriptionMarathi: "वर्णन (मराठी)",
  LegalReference: "कायदेशीर संदर्भ",
  DisplayOrder: "प्रदर्शन क्रम",
  ClassificationLevel: "वर्गीकरण स्तर",
  ActiveStatus: "सक्रिय स्थिती",
  LandClassification: "भूमी वर्गीकरण",
  AssessmentType: "मूल्यांकन प्रकार",
  RevenueCategory: "महसूल श्रेणी",
  DevelopmentPotential: "विकास क्षमता",
  TransferRestrictions: "हस्तांतरण निर्बंध",
  LandRateMultiplier: "जमिनीच्या दराचा गुणक",
  AgriculturalLand: "कृषी जमीन",
  IrrigationType: "सिंचन प्रकार",
  NonAgriculturalLand: "अकृषी जमीन",
  ForestLand: "वनभूमी",
  ForestCategory: "वन श्रेणी",
  GovernmentLand: "सरकारी जमीन",
  GovernmentDepartment: "सरकारी विभाग",
  GovernmentPurpose: "सरकारी उद्देश",
  AdditionalProperties: "अतिरिक्त गुणधर्म",
  GaothanArea: "गावठाण क्षेत्र",
  WaterBody: "जलक्षेत्र",
  SpecialEconomicZone: "विशेष आर्थिक क्षेत्र",
  TribalArea: "आदिवासी क्षेत्र",
  CoastalZone: "सागरी नियम क्षेत्र",
  HeritageSite: "वारसा स्थळ",
  CeilingApplicable: "मर्यादा लागू",
  TenancyApplicable: "भाडेकरू लागू",
  landtype: "भूमी प्रकार",
  SelectType: "प्रकार निवडा",
  Regular: "नियमित ",
  Exempt: "मुक्त",
  Special: "विशेष",
  SelectPotential: "संभाव्यता निवडा",
  Canal: "कालवा",
  Well: "विहीर",
  TubeWell: "ट्यूबवेल",
  Rainfed: "पावसाचे पाणी",
  SelectPattern: "नमुना निवडा",
  Seasonal: "हंगामी",
  Annual: "वार्षिक",
  Perennial: "बारमाही",
  Purpose: " उद्देश",
  Protected: "संरक्षित",
  Reserved: "राखीव",
  WaterBodyType: "पाण्याचा प्रकार",
  River: "नदी",
  Lake: "तलाव",
  Pond: "तलाव",
  Reservoir: "जलाशय",

  //RoleManagement
  searchUsers: "वापरकर्ते किंवा प्रकल्प शोधा...",
  addUser: "नवीन वापरकर्ता जोडा",
  username: "वापरकर्तानाव",
  mobileNo: "मोबाईल क्र.",

  noUsers: "कोणतेही वापरकर्ते उपलब्ध नाहीत",
  addUserPrompt: "सुरवात करण्यासाठी नवीन वापरकर्ता जोडा",
  Nousersfound: "कोणतेही जुळणारे वापरकर्ते आढळले नाहीत",
  Tryfilter: "तुमचा शोध शब्द अ‍ॅडजस्ट करून पहा किंवा फिल्टर साफ करा.",
  showingUsers: "{total} पैकी {count} वापरकर्ते दर्शवित आहे",

  title: "वापरकर्त्याची भूमिका नियुक्त करा",
  searchUsername: "वापरकर्त्याचे नाव शोधा",
  selectRole: "भूमिका निवडा",
  edituserrole: "वापरकर्ता भूमिका संपादित करा",
  selectproject: "प्रकल्प निवडा",
  ConfirmDeletion: "हटविण्याची पुष्टी करा",
  aysy: "तुम्हाला खात्री आहे की तुम्ही या वापरकर्त्याला हटवू इच्छिता? ही क्रिया पूर्ववत करता येणार नाही.",

  //Dashboard
  ProjectManagement: "प्रकल्प व्यवस्थापन",
  LandholdingList: "जमीनधारक यादी",
  AddLandholdingList: "जमीनधारक जोडा",
  EditLandholdingList: "जमीनधारक यादी संपादित करा",
  VillageManagement: "गाव व्यवस्थापन",
  MeasurementWiseObjection: "मोजणी नुसार हरकती",
  MeasurementViseObjectionForm: "मोजणी नुसार हरकत फॉर्म",
  MeasurementList: "मोजणी यादी",
  AcquisitionRecords: "संपादन नोंदी",
  Reports: "अहवाल",
  Section19: "कलम 19",
  Section23: "कलम 23",
  CoveringLetters: "भूसंपादन अधिकारी नियुक्ती",
  CoveringLettersSection11: "कलम 11 मान्यता",
  CoveringLettersSection19: "कलम 19 मान्यता",
  CoveringLettersSection15: "कलम 15 मान्यता",

  //UserManagement
  Error: "त्रुटी",
  tryagain: "पुन्हा प्रयत्न करा",
  adminusermanagement: "प्रशासन वापरकर्ता व्यवस्थापन",
  addnewuser: "नवीन वापरकर्ता जोडा",
  maml: "सर्व प्रशासक-स्तरीय वापरकर्ते, त्यांच्या भूमिका, लॉगिन क्रेडेन्शियल्स आणि प्रवेश स्थिती व्यवस्थापित करा.",
  DeleteSelected: "निवडलेले हटवा",
  name: "नाव",
  enterfullname: "पूर्ण नाव प्रविष्ट करा",
  Password: "पासवर्ड",
  ConPassword: "पासवर्ड कन्फर्म करा",
  Requiredfields: "आवश्यक फील्ड",
  EditUser: "वापरकर्ता संपादित करा",
  UpdateUser: "वापरकर्ता अद्यतनित करा",
  ConfirmDelete: "हटविण्याची पुष्टी करा",
  aysyw: "तुम्हाला नक्की वापरकर्ता हटवायचा आहे का? ",
  tacbu: "? ही क्रिया पूर्ववत करता येत नाही.",

  // SubUserManagement
  subUserLoader: "उप-वापरकर्ता लोड होते आहे...",
  work: "कार्य",
  addSubUser: "उप-वापरकर्ता जोडा",
  editSubUser: "उप-वापरकर्ता संपादित करा",
  noWorkAssignmentsAvailable: "कोणतीही कार्य नियुक्ती उपलब्ध नाही",
  enterPassword: "पासवर्ड प्रविष्ट करा",
  enterConfirmPassword: "पासवर्ड पुष्टी करा प्रविष्ट करा",

  //About
  BuldhanaCollector: " जिल्हाधिकारी कार्यालय बुलढाणा ",
  GovernmentOfMaharashtra: "महाराष्ट्र शासन",
  Login: "लॉगिन",
  Economy: "अर्थव्यवस्था",
  Administration: "प्रशासन",
  Gallery: "गॅलरी",
  Contact: "संपर्क",

  AboutBuldhana: "बुलढाणा जिल्ह्याबद्दल",
  BuldhanaTagline: "महाराष्ट्राचे हृदय, समृद्ध सांस्कृतिक आणि वारसा",
  Explore: "अन्वेषण करा",

  //District Overview
  DistrictOverview: "जिल्ह्याचा आढावा",
  Buldhanapara: "बुलढाणा हा पश्चिम भारतातील महाराष्ट्र राज्यातील अमरावती विभागातील एक जिल्हा आहे. पश्चिम विदर्भ प्रदेशात स्थित, तो त्याच्या कृषी समृद्धी, ऐतिहासिक महत्त्व आणि जगप्रसिद्ध लोणार क्रेटर सरोवर - एक अधिसूचित राष्ट्रीय भू-वारसा स्मारक यासाठी ओळखला जातो.",
  Population: "लोकसंख्या",
  Headquarters: "मुख्यालय",
  ldes: "विदर्भ प्रदेश, पूर्व महाराष्ट्र",
  ades: "९,६६१ चौरस किमी",
  pdes: "अंदाजे २.५ दशलक्ष",
  hdes: "बुलढाणा शहर",
  map: "बुलढाणा जिल्ह्याचा भौगोलिक नकाशा",

  //Geography & Climate
  GeographyClimate: "भूगोल आणि हवामान",
  LandscapeTopography: "भूदृश्य व स्थलरचना",
  ltp1: "बुलढाणा जिल्ह्याची भूरचना विविध आहे, उत्तरेला सातपुडा पर्वतरांगा आणि दक्षिणेला मैदाने आहेत. हा जिल्हा दख्खनच्या पठारावर वसलेला आहे आणि समुद्रसपाटीपासून त्याची उंची ४०० ते ८०० मीटर आहे.",
  ltp2: "सर्वात उल्लेखनीय भूगर्भीय वैशिष्ट्य म्हणजे लोणार क्रेटर सरोवर, जे सुमारे ५२,००० वर्षांपूर्वी उल्कापातामुळे तयार झाले. हे जगातील तिसरे सर्वात मोठे नैसर्गिक खाऱ्या पाण्याचे सरोवर आहे आणि बेसाल्टिक खडकांमधील एकमेव ज्ञात हायपर-वेग इम्पॅक्ट क्रेटर आहे.",
  ltp3: "या जिल्ह्यात पूर्णा नदी आणि तिच्या उपनद्या पाण्याचा निचरा करतात, ज्या तापी नदी प्रणालीचा भाग आहेत, ज्यामुळे शेतीसाठी आवश्यक असलेले जलस्रोत उपलब्ध होतात.",
  ClimateCharacteristics: "हवामान वैशिष्ट्ये",
  Rainfall: "पावसाळा",
  Summer: "उन्हाळा (मार्च–जून)",
  Winter: "हिवाळा (नोव्हेंबर–फेब्रुवारी)",
  Monsoon: "पावसाळा (जून–सप्टेंबर)",
  rd: "सरासरी वार्षिक पाऊस: ७००-९०० मिमी, प्रामुख्याने पावसाळ्यात (जून-सप्टेंबर)",
  sd: "३०°C ते ४५°C पर्यंत तापमानासह उष्ण आणि कोरडे",
  wd: "१०°C ते २५°C पर्यंत तापमानासह सौम्य आणि आल्हाददायक",
  md: "जिल्ह्यात मध्यम स्वरूपाचा पाऊस पडला.",

  //Culture & Festivals
  CultureFestivals: "संस्कृती आणि सण",
  ReligiousFestivals: "धार्मिक सण",
  FolkArtMusic: "लोककला आणि संगीत",
  Cuisine: "पाककृती",
  ReligiousFestivalspara: "गणेश चतुर्थी, दिवाळी आणि नवरात्र हे सण मोठ्या उत्साहात साजरे केले जातात. या सणांमध्ये निघणाऱ्या उत्साही मिरवणुका आणि सामुदायिक मेळाव्यांसाठी हा जिल्हा ओळखला जातो.",
  FolkArtMusicpara: "लावणी आणि कोळी सारखे पारंपारिक मराठी लोकनृत्य या प्रदेशात लोकप्रिय आहेत. ढोलकी आणि तबला सारख्या वाद्यांसह स्थानिक संगीत सांस्कृतिक ओळखीचा एक महत्त्वाचा भाग बनते.",
  Cuisinepara: "हा जिल्हा वडा पाव, पुरण पोळी आणि विविध कोशिंबीर (सलाद) सारख्या खास पदार्थांसह मसालेदार महाराष्ट्रीयन पाककृतींसाठी ओळखला जातो. सणांमध्ये बासुंदी आणि जलेबी सारख्या स्थानिक मिठाई लोकप्रिय असतात.",

  //Economy & Livelihood
  EconomyLivelihood: "अर्थव्यवस्था आणि उपजीविका",
  Cotton: "कापूस (मुख्य नगदी पीक)",
  Soybeans: "सोयाबीन",
  Pulses: "डाळी (तूर, मूग, उडीद)",
  JowarWheat: "ज्वारी आणि गहू",
  Fruits: "संत्री आणि मोसंबीसारखी फळे",
  IndustryServices: "उद्योग आणि सेवा",
  CottonGinning: "कापूस जिनिंग व प्रेसिंग युनिट्स",
  AgroProcessing: "कृषी प्रक्रिया उद्योग",
  SmallScaleIndustries: "खामगाव, माळकापूर व बुलडाणा येथील लघुउद्योग",
  HandicraftsHandloom: "हस्तकला आणि हातमाग क्षेत्र",
  ELP1: "बुलढाण्याच्या अर्थव्यवस्थेचा कणा शेती आहे, सुमारे ७०% लोकसंख्या शेतीवर अवलंबून आहे. जिल्हा त्याच्या उत्पादनासाठी ओळखला जातो:",
  ELP2: "जिल्ह्यात कृषी उत्पादकता वाढवण्यासाठी विविध सिंचन प्रकल्प राबविले आहेत, ज्यात पूर्णा आणि अप्पर वर्धा सिंचन प्रकल्पांचा समावेश आहे.",
  ELP3: "प्रामुख्याने शेतीप्रधान असले तरी, बुलढाणा हळूहळू औद्योगिक क्षेत्र विकसित करत आहे:",
  ELP4: "सेवा क्षेत्र वाढत आहे, प्रामुख्याने शहरी भागात, बँकिंग, शिक्षण, आरोग्यसेवा आणि सरकारी सेवा रोजगाराच्या महत्त्वपूर्ण संधी उपलब्ध करून देत आहेत. लोणार क्रेटर सरोवर आणि धार्मिक स्थळांभोवती केंद्रित पर्यटन हे एक उदयोन्मुख क्षेत्र आहे.",

  //Administrative Setup
  AdministrativeSetup: "प्रशासकीय रचना",
  DistrictAdministration: "जिल्हा प्रशासन",
  DistrictCollectorate: "जिल्हाधिकारी कार्यालय",
  ZillaParishad: "जिल्हा परिषद",
  MunicipalCouncils: "नगरपरिषदा",
  AdministrativeDivisions: "प्रशासकीय विभाग",
  Buldhana: "बुलढाणा",
  Chikhli: "चिखली",
  DeulgaonRaja: "देऊळगाव राजा",
  JalgaonJamod: "जळगाव जामोद",
  Malkapur: "माळकापूर",
  Mehkar: "मेहकर",
  Motala: "मोठाळा",
  Nandura: "नांदुरा",
  Sangrampur: "संग्रामपूर",
  Shegaon: "शेगाव",
  SindkhedRaja: "सिंदखेड राजा",
  Khamgaon: "खामगाव",
  Lonar: "लोणार",
  ASP1: "जिल्ह्याचे प्रशासन जिल्हाधिकारी (IAS अधिकारी) यांच्याकडून केले जाते जे विविध विभागांवर देखरेख करतात आणि सरकारी धोरणे आणि कार्यक्रमांची अंमलबजावणी सुनिश्चित करतात.",
  ASP2: "बुलढाणा शहरात स्थित, ते प्रशासकीय मुख्यालय म्हणून काम करते.",
  ASP3: "ग्रामीण भागातील विकास उपक्रमांचे व्यवस्थापन करते.",
  ASP4: "बुलढाणा, खामगाव, मलकापूर, शेगाव इत्यादी शहरी भागांचे व्यवस्थापन करा.",
  ASP5: "कार्यक्षम प्रशासन आणि प्रशासनासाठी बुलढाणा जिल्हा १३ तहसील (प्रशासकीय विभाग) मध्ये विभागलेला आहे:",

  //District Gallery
  DistrictGallery: "जिल्हा गॅलरी",
  LonarCraterLake: "लोणार क्रेटर तलाव",
  ShegaonTemple: "शेगाव मंदिर",
  SindkhedRajaFort: "सिंदखेड राजा किल्ला",
  BuldhanaCity: "बुलढाणा शहर",

  //HomePage
  Home1: "मुखपृष्ठ",
  Overview: "आढावा",
  LandAcquisition: "जमीन संपादन",
  ViewNivada: "दस्तऐवज शोध",

  Pause: "थांबवा",
  Play: "चालू करा",
  LiveData: "थेट माहिती",
  RealTimeUpdates: "क्षणाक्षणाची अद्यतने",
  LocationNotSpecified: "स्थान निर्दिष्ट नाही",
  Stakeholders: "हितधारक",
  ClickToViewDetails: "तपशील पाहण्यासाठी क्लिक करा",
  BuldhanaLand: "बुलढाणा भूमि",
  AcquisitionPortal: " संपादन पोर्टल",
  AcquisitionTagline: "बुलढाणा जिल्ह्यातील विकास प्रकल्पांसाठी पारदर्शक आणि कार्यक्षम भू-संपादन प्रक्रिया",

  BuldhanaGlance: "बुलढाणा जिल्ह्याचा आढावा",
  GlanceTagline: "आमच्या समृद्ध जिल्ह्याचा संक्षिप्त परिचय आणि महत्त्वाची आकडेवारी",
  BuldhanaOverview: "बुलढाणा जिल्ह्याचे विहंगावलोकन",
  DevelopingHub: "महाराष्ट्राचा विकसित होणारा केंद्रबिंदू",
  KeyHighlights: "मुख्य वैशिष्ट्ये",
  GrowthTagline: "प्रादेशिक विकास व वाढीस चालना",
  GeoHeritage: "राष्ट्रीय भूवारसा स्मारक",

  AgriculturalHub: "कृषी केंद्र",
  VidarbhaProducer: "विदर्भातील मुख्य उत्पादक",

  EducationalGrowth: "शैक्षणिक वाढ",
  NewUniversities: "नवीन विद्यापीठे व संस्था निर्माणात",

  ImprovedConnectivity: "सुधारित संपर्क",
  ConnectivityUpgrades: "प्रमुख महामार्ग व रेल्वे पायाभूत सुविधा उन्नती",

  CulturalDiversity: "सांस्कृतिक विविधता",
  HeritageTagline: "समृद्ध वारसा दर्शवणारे उत्सव आणि परंपरा",

  DistrictFacts: "जिल्ह्याची माहिती",
  AreaValue: "९,६६१ चौ.कि.मी.",
  PopulationValue: "२.६ दशलक्ष",
  HeadquartersValue: "बुलढाणा शहर",
  Established: "स्थापना",
  EstablishedValue: "१९०५",
  Subdivisions: "उपविभाग",
  SubdivisionsValue: "१३ तालुके",

  Infrastructure: "पायाभूत सुविधा",
  RoadNetwork: "रस्ते जाळे",
  RoadValue: "३,२०० कि.मी. रस्ते जिल्हाभर",
  IrrigationProjects: "सिंचन प्रकल्प",
  IrrigationValue: "१५ प्रमुख सिंचन प्रकल्प चालू",
  EducationFacilities: "शैक्षणिक सुविधा",
  EducationValue: "१,२००+ शाळा व २५ महाविद्यालये",
  HealthcareCenters: "आरोग्य केंद्रे",
  HealthcareValue: "६८ रुग्णालये व आरोग्य केंद्रे",

  WantToLearn: "बुलढाण्याच्या विकास उपक्रमांबद्दल अधिक जाणून घ्यायचे आहे का?",
  ExploreDistrict: "आमचा व्यापक जिल्हा प्रोफाईल आणि चालू प्रकल्पांचा अभ्यास करा.",
  ExploreProfile: "जिल्हा प्रोफाईल पाहा",
  DevelopmentProjects: "विकास प्रकल्प",
  ViewAllProjects: "सर्व प्रकल्प पहा",
  ProjectOverviewStats: "प्रकल्प आढावा आकडेवारी",
  AboutDistrict: "बुलढाणा जिल्ह्याबद्दल",
  Aboutdes1: "बुलढाणा जिल्हा हा भारतातील महाराष्ट्र राज्यातील विदर्भ प्रदेशात स्थित आहे. हा जिल्हा त्याच्या कृषी उत्पादकतेसाठी ओळखला जातो आणि पायाभूत सुविधा आणि आर्थिक विकास सुधारण्याच्या उद्देशाने अनेक विकास प्रकल्प येथे सुरू आहेत.",
  Aboutdes2: "रस्ते, धरणे आणि औद्योगिक क्षेत्रे यासारख्या सार्वजनिक प्रकल्पांसाठी आवश्यक असलेल्या सर्व भूसंपादनांसाठी योग्य भरपाई आणि पारदर्शक प्रक्रिया सुनिश्चित करण्यासाठी भूसंपादन विभाग प्रयत्नशील आहे.",

  TotalProjects: "एकूण प्रकल्प",
  ActiveProjects: "सक्रिय प्रकल्प",
  Categories: "श्रेणी",
  About: "विषयी",
  Punarbhu: "पुनर्भू",
  Punarbhu1: "भूसंपादन प्रणाली",
  LearnMore: "अधिक जाणून घ्या",
  DevelopmentTitle: "बुलढाणा जिल्हा विकास",
  DevelopmentDesc: "बुलढाणा जिल्ह्यात परिवर्तन घडवणारे केंद्रित उपक्रम आणि प्रकल्प",
  AtAGlance: "थोडक्यात",
  DevelopmentFocus: "विकास केंद्रबिंदू",
  ProgressOverview: "प्रगतीचा आढावा",

  DistrictIntro: "बुलढाणा जिल्हा पश्चिम विदर्भात 9,661 चौ.कि.मी. क्षेत्रात पसरलेला असून, सुमारे 2.5 दशलक्ष लोकसंख्या आणि 13 तालुक्यांचा समावेश आहे.",
  DevelopmentFocus1: "कृषी पायाभूत सुविधा, जलसंपत्ती, रस्ते संपर्क आणि शाश्वत ग्रामीण विकासाला प्राधान्य.",
  OngoingProjects: "सध्या पायाभूत सुविधा आणि कृषी क्षेत्रातील सर्वसमावेशक विकासासाठी प्रमुख प्रकल्प कार्यान्वित.",
  ContactUs: "संपर्क साधा",
  ContactInfo: "कोणतेही प्रश्न किंवा मदतीसाठी आमच्या टीमशी संपर्क साधा",
  Addressbuldhana: "कार्यालयाचा पत्ता",
  OfficeAddress: "जिल्हाधिकारी कार्यालय, बुलढाणा, महाराष्ट्र - 443001",
  PhoneContact: "दूरध्वनी संपर्क",
  EmailSupport: "ईमेल समर्थन",
  AllStatus: "सर्व स्थिती",
  InactiveProjects: "निष्क्रिय प्रकल्प",
  NotificationIssued: "सूचना जारी",
  LandMarkingInProgress: "जमिनीचे चिन्हांकन चालू आहे",
  SiteInspectionCompleted: "स्थळ पाहणी पूर्ण",
  CompensationProcessing: "भरपाई प्रक्रिया सुरू",
  ShowingOfTotal: "एकूण",
  TProjects: "प्रकल्प दर्शवले जात आहेत",
  ClearAll: "सर्व साफ करा",
  NoProjectsFound: "कोणताही प्रकल्प आढळला नाही",
  TryAdjusting: "तुमचा शोध किंवा फिल्टर समायोजित करा",
  ClearAllFilters: "सर्व फिल्टर हटवा",
  BhudharakArea: "भूधारक क्षेत्र",
  Started: "सुरु झाला",
  Complete: "पूर्ण",
  ProjectInformation: "प्रकल्प माहिती",
  SelectProposal: "प्रस्ताव निवडा",
  RoadInfraNote: "राज्य शासन/केंद्रशासित विभागांतर्गत रस्ते पायाभूत सुविधा प्रकल्प. जमीन संपादन क्रमांक: उपलब्ध नाही",
  People: "लोक",
  PleaseWait: "कृपया प्रतीक्षा करा",
  CurrentlyManaging: "सध्या व्यवस्थापनाखाली",
  ActiveProjectsInDistrict: "बुलढाणा जिल्ह्यातील सक्रिय प्रकल्प",
  ShowingActiveProjects: "सक्रिय प्रकल्प दर्शवित आहे",
  PreliminarySurvey: "प्राथमिक सर्वेक्षण",
  LandSurveyCompleted: "जमीन सर्वेक्षण पूर्ण",
  LandMarkingProgress: "जमिनीचे चिन्हांकन सुरू",
  CompensationFinalized: "भरपाई अंतिम केली",
  FinalAssessment: "अंतिम मूल्यांकन",
  ProjectArea: "प्रकल्प क्षेत्र",
  CurrentStatus: "सध्याची स्थिती",
  Division: "विभाग",
  LastUpdated: "शेवटचा अद्ययावत",
  BudharakCount: "बुधारक संख्या",
  Description1: "वर्णन",
  AdministrativeDetails: "प्रशासकीय तपशील",
  LandAcquisitionNo: "जमीन संपादन क्र.",
  AdministrativeOrderNo: "प्रशासकीय आदेश क्र.",
  RaiseObjection: "हरकत नोंदवा",
  LastDateWarning: "आक्षेप नोंदवण्याची तारीख ओलांडली आहे (अंतिम तारीख:",
  SelectOwner: "भोगवटदार निवडा",
  OwnerWarning: "मालिकांना लोड करण्यासाठी गॅट क्रमांक प्रविष्ट करा", uploadDocumentss: "कागदपत्र अपलोड करा",
  field: "मुद्दा",
  value: "तपशील ",

  PortalTitle: "बुलढाणा जिल्हा, महाराष्ट्र साठी अधिकृत जमीन संपादन व व्यवस्थापन पोर्टल",
  QuickLinks: "त्वरित दुवे",
  ImportantResources: "महत्त्वाचे स्रोत",
  MaharashtraGovernment: "महाराष्ट्र शासन",
  Sahajpranali: "सहजप्रणाली",
  Jigaon: "जिगाव",
  AmravatiDivision: "अमरावती विभाग",
  AapleSarkar: "आपले सरकार",
  OfficeHours: "कार्यालयीन वेळा",
  MondaytoFriday: "सोमवार ते शुक्रवार",
  Saturday: "शनिवार",

  //login
  SignIn: "साइन इन करा",
  AdminSignIn: "प्रशासक साइन इन",
  EnterCredentials: "कृपया आपली माहिती खाली प्रविष्ट करा",
  EmailOrMobile: "ईमेल किंवा मोबाइल नंबर",
  ForgotPassword: "पासवर्ड विसरलात?",
  SignInButton: "साइन इन करा",
  SwitchToAdmin: "प्रशासक साइन इन वर स्विच करा",
  SwitchtoUserSignIn: "वापरकर्ता साइन इन वर स्विच करा",
  NoAccount: "खाते नाहीये?",
  OR: "किंवा",
  SigningIn: "साइन इन करत आहे",

  SignUp: "साइन अप करा",
  CreateAccount: "खाते तयार करा",
  JoinPlatform: "आजच आमच्या प्लॅटफॉर्ममध्ये सामील व्हा",
  FirstName: "पहिले नाव",
  LastName: "आडनाव",
  ConfirmPassword: "पासवर्डची पुष्टी करा",
  workAssign: "कार्य नियुक्त करा",
  TermsAgreement: "मी सेवा अटी व गोपनीयता धोरणास मान्यता देतो",
  CreateAccountButton: "खाते तयार करा",
  AlreadyHaveAccount: "आधीच खाते आहे?",

  //ForgotPassword
  BackToSignIn: "परत साइन इन करा",
  DontWorry: "चिंता करू नका, आम्ही तुमचा पासवर्ड रीसेट करण्यात मदत करू",
  SendCodeInfo: "तुमचा पासवर्ड रीसेट करण्यासाठी तुमच्या ईमेलवर एक पडताळणी कोड पाठवू",  
  SendVerificationCode: "पडताळणी कोड पाठवा",
  VerifyCode: "कोड पडताळा",
  EnterCodePrompt: "पाठवलेला 6-अंकी कोड प्रविष्ट करा",
  VerificationCode: "पडताळणी कोड",
  Resending: "पुन्हा पाठवत आहे",
  DidntReceiveCode: "कोड मिळाला नाही? पुन्हा पाठवा",
  Verifying: "पडताळत आहे",
  VerifyAndContinue: "पडताळा आणि पुढे जा",
  ResetPassword: "पासवर्ड रीसेट करा",
  NewPasswordPrompt: "तुमच्या खात्यासाठी नवीन पासवर्ड तयार करा",
  NewPassword: "नवीन पासवर्ड",
  Resetting: "रीसेट करत आहे",

  //AreaUnitManagement
  AreaUnitManagement: "क्षेत्र एकक व्यवस्थापन",

  loadingAreaUnits: "क्षेत्र एकक लोड होत आहेत...",
  error: "त्रुटी",
  addNewAreaUnit: "नवीन क्षेत्र एकक जोडा",
  sNo: "अनु क्र.",
  unitName: "एककाचे नाव",
  unitCode: "एकक कोड",
  conversionToSqm: "वर्ग मीटरमध्ये रूपांतर",
  noAreaUnitsFoundMatching: "आपल्या निकषांशी जुळणारी कोणतीही क्षेत्र एकके सापडली नाहीत",
  entries: "नोंदी",
  noAreaUnitsFound: "कोणतीही क्षेत्र एकके आढळली नाहीत. प्रारंभ करण्यासाठी \"एरिया युनिट जोडा\" वर क्लिक करा",
  Sau: "क्षेत्र एकके शोधा...",
  AddArea: "नवीन क्षेत्र युनिट जोडा",
  EditAre: "क्षेत्र युनिट संपादित करा",

  //ConcernValuer
  filterChange: "फिल्टर आणि बदला",
  changeConcernValuer: "संबंधित मूल्यांकनकर्ता बदला",
  sendToLAO: "भूसंपादन अधिकाऱ्यांना पाठवा",
  selectedRecords: "निवडलेले",
  ownerDetails: "मालकाची माहिती",
  landRate: "जमिनीचा दर (₹/वर्ग मी.)",
  landAmount: "जमिनीची रक्कम (₹)",
  treeDetails: "झाडांचे तपशील",
  cropDetails: "पिकांचे तपशील",
  totalCompensation: "एकूण भरपाई",
  unknownOwner: "अज्ञात मालक",
  na: "उपलब्ध नाही",
  count: "संख्या",
  showingRecords: "नोंदी दर्शवत आहे",

  SelectAgencyType: "एजन्सी प्रकार निवडा",
  ChooseAgency: "संबंधित नुकसानभरपाई व्यवस्थापनासाठी आपली एजन्सी निवडा",
  ContinueToCompensation: "नुकसानभरपाई व्यवस्थापन सुरू ठेवा",
  WhatNext: "पुढे तुम्हाला काय दिसेल",
  LoadingData: "नुकसानभरपाई डेटा लोड होत आहे...",
  Filters: "फिल्टर",
  PleaseSelectDistrict: "कृपया नुकसानभरपाई डेटा पाहण्यासाठी किमान जिल्हा निवडा. आपण वैकल्पिकरित्या तालुका आणि गाव देखील निवडू शकता.",
  SendBackToLAO: "भूसंपादन  अधिकाऱ्याला परत पाठवा",
  SelectLAOUser: "भूसंपादन अधिकारी",
  Structure: "रचना",
  Borewell: "बोअरवेल",
  Pipeline: "पाईपलाईन",
  TinShed: "टिन शेड",
  Wire: "तार",
  OtherAsset: "इतर मालमत्ता",
  LoadingCompensationRecords: "नुकसानभरपाई रेकॉर्ड लोड होत आहे...",
  Records: "रेकॉर्ड",
  PleaseSelectAtLeastDistrict: "कृपया वरील फिल्टर पॅनेलमधून किमान जिल्हा निवडा. आपण वैकल्पिकरित्या तालुका आणि गाव देखील निवडू शकता.",
  AgencySelected: "संस्था निवडली",
  ChangeConcernValuer: "संबंधित मूल्यांकनकर्ता बदला",
  LoadingOfficers: "अधिकारी लोड होत आहेत...",
  SelectOfficer: "अधिकारी निवडा",
  LandAmount: "जमीन रक्कम",
  Details: "तपशील",
  Tree: "झाड",
  Crop: "पीक",
  YouAreAboutToProceed: "आपण पुढे जाणार आहात",
  DoYouReallyWantToContinuePendingSurveys: "आपण खरोखर पुढे जायचे आहे का? अजून काही सर्वेक्षण सत्यापित करायचे बाकी आहेत.",
  YesContinue: "होय, पुढे जा",
  consulting_agent: "सल्लागार एजंट",
  VillageCouncil: "ग्राम परिषद",
  TreeAndCropCompensationManagementInterfaceWithRelevantFieldsOnly: "केवळ संबंधित फील्डसह झाड आणि पिक भरपाई व्यवस्थापन इंटरफेस",
  TreeCompensationManagementInterfaceFocusedOnForestryAssets: "वन संपत्तीवर लक्ष केंद्रित केलेले झाड भरपाई व्यवस्थापन इंटरफेस",
  InfrastructureAndAssetCompensationInterfaceForConsultingWork: "सल्लागार कामासाठी पायाभूत सुविधा आणि मालमत्ता भरपाई इंटरफेस",
  CompleteCompensationManagementInterfaceWithAllAvailableCategories: "सर्व उपलब्ध श्रेणींसह पूर्ण भरपाई व्यवस्थापन इंटरफेस",
  Yearofexcavation: "खोदल्याचे वर्ष",
  NewOtherAsset: "इतर बांधकाम",
  lengthheight: " लांबी * उंची",
  actualDepth: "प्रत्यक्ष खोली",
  //CreateMeasurment
  createNewMeasurement: "नवीन मोजमाप तयार करा",
  measurementCreated: "मोजमाप यशस्वीरित्या तयार झाले! फॉर्म आपोआप बंद होईल.",
  landAcquisitionId: "भू-संपादन आयडी",
  ownerType: "मालकाचा प्रकार",
  individual: "वैयक्तिक",
  corporate: "कॉर्पोरेट",
  Email: "ईमेल",
  identityInformation: "ओळखीची माहिती",
  AadhaarNumber: "आधार क्र.",
  idProofType: "ओळखपत्राचा प्रकार",
  idProofNumber: "ओळखपत्र क्रमांक",
  PANNumber: "पानकार्ड क्र.",
  bankInformation: "बँक माहिती",
  bankName: "बँकेचे नाव",
  branchName: "शाखेचे नाव",
  accountNumber: "खाते क्रमांक",
  ifscCode: "IFSC कोड",
  accountHolderName: "खातेदाराचे नाव",
  landInformation: "जमिनीची माहिती",
  talukaName: "तालुक्याचे नाव",
  districtName: "जिल्हा",
  areaUnitId: "क्षेत्र एकक आयडी",
  areaUnit:"क्षेत्र एकक",
  landTypeId: "जमिनीचा प्रकार आयडी",
  titleType: "हक्क प्रकार",
  landCategory: "जमिन प्रकार",
  landUse: "जमिनीचा वापर",
  ownershipPercentage: "मालकी टक्केवारी",
  valuationInformation: "मूल्यांकन माहिती",
  landValueRate: "जमिनीचा दर",
  totalLandValue: "एकूण जमिनीचे मूल्य",
  structureValue: "इमारतीचे मूल्य",
  treeValue: "झाडांचे मूल्य",
  cropValue: "पिकांचे मूल्य",
  waterBodyValue: "जलस्रोत मूल्य",
  otherAssetValue: "इतर मालमत्तेचे मूल्य",
  solatiumPercentage: "सांत्वन टक्केवारी",
  solatiumAmount: "सांत्वन रक्कम",
  hasObjection: "हरकत आहे",
  objectionId: "हरकतीचा आयडी",
  documentInformation: "दस्तऐवज माहिती",
  acquisitionDate: "संपादनाची तारीख",
  documentNumber: "दस्तऐवज क्रमांक",
  registrationDate: "नोंदणी तारीख",
  mutationNumber: "म्युटेशन क्रमांक",
  awardNumber: "पुरस्कार क्रमांक",
  awardDate: "पुरस्कार तारीख",
  documentReferences: "दस्तऐवज संदर्भ",

  //DirectPayment
  DirectPurchaseInfo: "खरेदी विक्री माहिती संपादित करा",
  AddDirectPurchaseRecord: "खरेदी विक्री नोंद जोडा",
  ClearFilters: "फिल्टर साफ करा",
  LoadingDirectPurchaseRecords: "खरेदी विक्री नोंदी लोड होत आहेत...",
  NoDirectPurchaseRecordsFound: "कोणतीही खरेदी विक्री नोंद सापडली नाही",
  BeneficiaryName: "लाभार्थ्याचे नाव",
  PurchaseDate: "खरेदीची तारीख *",
  Farmer: "शेतकरी",
  Organization: "संस्था",
  IDProofInformation: "ओळख पुरावा माहिती",
  IDProofType: "ओळख पुरावा प्रकार",
  AadhaarCard: "आधार कार्ड",
  PANCard: "पॅन कार्ड",
  VoterID: "मतदार ओळखपत्र",
  DrivingLicense: "वाहन चालवण्याचा परवाना",
  Passport: "पासपोर्ट",
  IDProofNumber: "ओळख पुरावा क्रमांक",
  LandType: "जमिनीचा प्रकार",
  SelectLandType: "जमिनीचा प्रकार निवडा",
  Residential: "निवासी",
  Commercial: "व्यावसायिक",
  Industrial: "औद्योगिक",
  RegistrationDate: "नोंदणी तारीख",
  MutationNumber: "म्युटेशन क्रमांक",
  LandValueRate: "जमिनीचा दर (प्रति युनिट)",
  TotalLandValue: "एकूण जमिनीचे मूल्य",
  AdditionalInformation: "अतिरिक्त माहिती",
  DocumentReferences: "दस्तऐवजीकरण संदर्भ",
  ChooseFile: "फाईल निवडा",
  AcceptedFormats: "स्वीकृत फॉरमॅट्स: PDF, DOC, DOCX, JPG, JPEG, PNG (कमाल 10MB)",
  AddDirectPurchase: "प्रत्यक्ष खरेदी जोडा",
  EditDirectPurchase: "प्रत्यक्ष खरेदी संपादित करा",


  //AddOwner
  Valid: "वैध",
  DocumentStatus: "दस्तऐवज स्थिती:",
  FileName: "फाईलचे नाव",
  FileSize: "फाईल आकार",
  Replace: "बदला",
  Upload: "अपलोड",
  AddNewPropertyOccupant: "नवीन मालमत्ता धारक जोडा",
  CompleteallsectionstoaddtheOccupantsuccessfully: "मालमत्ता धारक यशस्वीरित्या जोडण्यासाठी सर्व विभाग भरा",
  OccupantInformation: "धारकाची माहिती",
  BasicdetailsaboutthepropertyOccupant: "मालमत्ता धारकाबद्दलची मूलभूत माहिती",
  OccupantName: "धारकाचे नाव *",
  OccupantType: "धारक प्रकार",
  SelectOccupanttype: "धारक प्रकार निवडा",
  JointOccupant: "संयुक्त धारक",
  CompanyCorporation: "कंपनी/कॉर्पोरेशन",
  EmailAddress: "ईमेल ID",
  CompleteAddress: "पूर्ण पत्ता",
  IdentityDocuments: "ओळख दस्तऐवज",
  AadhaarNumberDocument: "आधार कार्ड दस्तऐवज",
  PANNumberDocument: "पॅन कार्ड दस्तऐवज",
  OccupantPortionDocument: "धारकाचा हिस्सा दस्तऐवज",
  LocationInformationMedia: "स्थान माहिती आणि मीडिया",
  Geographiccoordinateslocationdetailsandpropertymediafiles: "भौगोलिक निर्देशांक, स्थान तपशील आणि मालमत्ता मीडिया फायली",
  GPSCoordinates: "जीपीएस निर्देशांक",
  GettingLocation: "स्थान मिळवत आहोत...",
  GetLocation: "स्थान मिळवा",
  ViewonMap: "नकाशावर पाहा",
  PropertyMediaFiles: "मालमत्ता मीडिया फायली",
  Uploadimagesandvideosofthepropertyfordocumentationandverification: "मालमत्तेचे चित्र व व्हिडिओ अपलोड करा दस्तऐवजीकरण व पडताळणीसाठी",
  PropertyDetails: "मालमत्ता तपशील",
  Landownershipandcompensationdetails: "जमीन मालकी व भरपाई तपशील",
  Acquired: "संपादित",
  Required: "आवश्यक",
  TotalOccupantLandPortion: "एकूण धारक जमीन हिस्सा",
  OccupandLandAcquisitionValue: "धारक जमिनीचा संपादन मूल्य",
  MustbeLessThanEqualTotalOccupantLandPortion: "एकूण धारक जमीन हिस्स्यापेक्षा कमी किंवा बरोबर असावे",
  Autocalculated: "स्वयं गणना: एकूण हिस्सा ÷ संपादन मूल्य × 100",
  MixedUse: "मिश्र वापर",
  CurrentLandUse: "सध्याचा जमीन वापर",
  Selectlanduse: "जमीन वापर निवडा",
  Farming: "शेती",
  VacantLand: "रिकामी जमीन",
  ResidentialBuilding: "निवासी इमारत",
  Warehouse: "गोडाऊन",
  AdditionalPropertyAssets: "अतिरिक्त मालमत्ता साधने",
  NoofTree: "झाडांची संख्या",
  NoofHome: "घरांची संख्या",
  NoofTinShedGodown: "टिन शेड/गोडाऊनची संख्या",
  NoofWellShevLake: "विहीर/तळ्यांची संख्या",
  NoofBoreWell: "बोरवेलची संख्या",
  NoofPipeline: "पाईपलाइनची संख्या",
  NoofWireFence: "तार कुंपणांची संख्या",
  File: "फाईल",
  Size: "आकार",
  documentStatus: "दस्तऐवज स्थिती",
  fileName: "फाईल नाव",
  fileSize: "फाईल आकार",
  addNewPropertyOccupant: "नवीन मालमत्ता धारक जोडा",
  completeSectionsToAddOccupant: "धारक यशस्वीरित्या जोडण्यासाठी सर्व विभाग पूर्ण करा",
  locationAndMedia: "स्थान आणि मीडिया",
  basicDetailsAboutOccupant: "मालमत्ता धारकाबद्दल मूलभूत तपशील",
  selectOccupantType: "धारकाचा प्रकार निवडा",
  jointOccupant: "संयुक्त धारक",
  companyCorporation: "कंपनी/कॉर्पोरेशन",
  completeAddress: "संपूर्ण पत्ता",
  enterCompleteAddress: "संपूर्ण पत्ता व पिनकोड टाका",
  punchnamaDocuments: "पंचनामा कागदपत्रे",
  geoCoordinates: "भौगोलिक निर्देशांक, स्थान तपशील व मालमत्ता मीडिया फाईल्स",
  gpsCoordinates: "जीपीएस निर्देशांक",
  gettingLocation: "स्थान मिळवत आहे...",
  getLocation: "स्थान मिळवा",
  viewOnMap: "नकाशावर पहा",
  punchnama: "पंचनामा",
  punchnamaPropertyImage: "पंचनामा मालमत्ता प्रतिमा",
  punchnamaPropertyVideo: "पंचनामा मालमत्ता व्हिडिओ",
  landOwnershipDetails: "जमीन मालकी व भरपाई तपशील",
  required: "आवश्यक",
  totalOccupantLandPortion: "एकूण धारक जमिनीचा भाग",
  mustBeLessEqualTotalArea: "एकूण जमिनीच्या क्षेत्रापेक्षा ≤ असावा",
  mustBeLessEqualOccupantArea: "एकूण धारक जमिनीच्या भागापेक्षा ≤ असावा",
  autoCalculatedTotalPortion: "स्वयंचलित गणना: एकूण जमिनीचा भाग ÷ अधिग्रहण किंमत × 100",
  autoCalculatedOrManual: "स्वयंचलित गणना किंवा मॅन्युअल भरा",
  mixedUse: "मिश्र वापर",
  currentLandUse: "सध्याचा जमिनीचा वापर",
  selectLandUse: "जमिनीचा वापर निवडा",
  farming: "शेती",
  vacantLand: "रिकामी जमीन",
  residentialBuilding: "निवासी इमारत",
  commercialBuilding: "व्यावसायिक इमारत",
  warehouse: "गोदाम",
  additionalAssets: "अतिरिक्त मालमत्ता",
  enterNumber: "संख्या टाका",
  enterNoOfHouses: "घरांची संख्या टाका",
  noOfPipeline: "पाईपलाईनची संख्या",
  noOfTinShed: "टिनशेड/गोदामांची संख्या",
  noOfWellShevLake: "विहिरी/तलावांची संख्या",
 
  //EditProject
  Loadingdocument: "दस्तऐवज लोड केला जात आहे...",
  Previewnotavailable: "पूर्वदृश्य उपलब्ध नाही",
  ThisdocumentcannotbepreviewedinthebrowserYoucandownloadittoview: "हा दस्तऐवज ब्राउझरमध्ये पाहता येणार नाही. कृपया डाउनलोड करा.",
  Success: "यशस्वी!",
  Projectupdatedsuccessfully: "प्रकल्प यशस्वीरित्या अद्ययावत झाला",
  CurrentStage: "सध्याचा टप्पा",
  Thisfieldisnoteditable: "हे क्षेत्र संपादनयोग्य नाही",
  ProjectInchargeName: "प्रकल्प प्रमुखाचे नाव",
  Projectisactive: "प्रकल्प सक्रिय आहे",
  ProjectBanner: "प्रकल्प बॅनर",
  UploadProjectBanner: "प्रकल्प बॅनर अपलोड करा",
  Supportedformats: "समर्थित स्वरूप: JPG, PNG, GIF. कमाल आकार: 5MB",
  TotalLandParcel: "एकूण जमीन तुकडे",
  NumberofLandOwner: "जमीन मालकांची संख्या",
  Enteracquisitionnumber: "अधिग्रहण क्रमांक प्रविष्ट करा",
  Enternumber: "संख्या प्रविष्ट करा",
  UpdateProject: "प्रकल्प अद्ययावत करा",
  PressESCToClose: "बंद करण्यासाठी ESC दाबा",

  //EditProposal
  Print: "प्रिंट",
  UploadSignature: "स्वाक्षरी अपलोड करा",
  UpdateProposal: "प्रस्ताव अद्ययावत करा",
  ProposalBudget: "प्रस्ताव बजेट",
  DepartmentInformation: "विभागीय माहिती",
  AcquisitionAgency: "संपादन संस्था",
  AcquisitionPurpose: "संपादनाचा उद्देश",
  Descriptions: "वर्णन",
  ProposalDescription: "प्रस्तावाचे वर्णन",
  SocialImpact: "सामाजिक परिणाम",
  SocialBenefit: "सामाजिक लाभ",
  DisplacementReason: "स्थलांतराचे कारण",
  ExemptionInformation: "सूट माहिती",
  IsExemptionApplicable: "सूट लागू आहे का?",
  SelectOption: "पर्याय निवडा",
  Yes: "होय",
  ExemptionType: "सूट प्रकार",
  SocialEnvironmentImpactSurvey: "सामाजिक व पर्यावरणीय परिणाम सर्वेक्षण",
  GovernmentAuthority: "शासकीय प्राधिकरण",
  IrrigationProject: "सिंचन प्रकल्प",
  ExemptionNotificationNumber: "सूट अधिसूचना क्रमांक",
  UploadExemptionFile: "सूट फाईल अपलोड करा",
  PDForImagefilesonly: "(फक्त PDF किंवा प्रतिमांची फाईल्स)",
  Currentfile: "सध्याची फाईल",
  Uploadanewfiletoreplacethecurrentone: "सध्याची फाईल बदलण्यासाठी नवीन फाईल अपलोड करा",
  Newfileselected: "नवीन फाईल निवडली आहे",
  UpdateProposalBtn: "प्रस्ताव अद्ययावत करा",

  //Hearing
  completedHearing: "पूर्ण झालेली सुनावणी",
  scheduleNewHearing: "नवीन सुनावणी ठरवा",
  loadingHearingData: "सुनावणी डेटा लोड होत आहे...",
  noObjectionSelected: "कोणतीही हरकत निवडलेली नाही",
  selectObjectionFirst: "सुनावणी व्यवस्थापित करण्यासाठी कृपया प्रथम हरकत निवडा.",
  hearingScheduledSuccess: "सुनावणी यशस्वीपणे ठरवली गेली!",
  hearingScheduledMessage: "आपली सुनावणी ठरवली गेली आहे आणि सूचना पाठवल्या जातील.",
  objectionRaisedDate: "हरकत नोंदवण्याची तारीख",
  hearingDetails: "सुनावणी तपशील",
  hearingStatus: "सुनावणीची स्थिती",
  selectStatus: "स्थिती निवडा",
  statusScheduled: "ठरवलेली",
  statusCompleted: "पूर्ण",
  dateWithin60Days: "तारीख 60 दिवसांच्या आत असावी",
  hearingTime: "सुनावणी वेळ",
  hearingLocation: "सुनावणी ठिकाण",
  enterHearingLocation: "सुनावणी ठिकाण प्रविष्ट करा",
  officerInformation: "अधिकाऱ्याची माहिती",
  officerName: "अधिकाऱ्याचे नाव",
  enterOfficerName: "अधिकाऱ्याचे नाव प्रविष्ट करा",
  officerDesignation: "अधिकाऱ्याचे पद",
  enterOfficerDesignation: "अधिकाऱ्याचे पद प्रविष्ट करा",
  caseDetails: "प्रकरण तपशील",
  objectionDetails: "हरकतीचा तपशील",
  finalDecision: "अंतिम निर्णय",
  finalVerdictRequiredMessage: "सुनावणी पूर्ण करताना अंतिम निर्णय दस्तऐवज आवश्यक आहे",
  documentUpload: "दस्तऐवज अपलोड",
  finalVerdictRequired: "अंतिम निर्णय आवश्यक",
  uploadDocuments: "दस्तऐवज अपलोड करा",
  clickToUpload: "अपलोड करण्यासाठी क्लिक करा",
  maxFileSize: "कमाल फाईल आकार: प्रति फाईल 10MB",
  uploadedDocuments: "अपलोड केलेले दस्तऐवज",
  uploadingDocuments: "दस्तऐवज अपलोड होत आहेत...",
  documentsUploadedSuccess: "सर्व दस्तऐवज यशस्वीपणे अपलोड झाले",
  submitting: "सबमिट करत आहे...",
  scheduling: "ठरवत आहे...",
  scheduleHearing: "सुनावणी ठरवा",
  hearingNotice: "सुनावणी सूचना",
  printNotice: "सूचना प्रिंट करा",
  uploadFinalVerdictPDF: "अंतिम निर्णय अपलोड करा (PDF)",
  uploadHearingNoticePDF: "सुनावणी सूचना अपलोड करा (PDF)",
  objectionCaseDetails: "हरकतीच्या प्रकरणाचा तपशील",
  objectionSummary: "हरकतीचा सारांश",
  objectorInformation: "हरकत नोंदवणाऱ्याची माहिती",
  hearingStatusManagement: "सुनावणी स्थिती व्यवस्थापन",
  hearingDate: "सुनावणी तारीख",
  objectionHearingProgress: "हरकत सुनावणी प्रगती",
  resolvedOn: "निपटारा दिनांक",
  attachedDocuments: "संलग्न दस्तऐवज",
  noDocumentsAttached: "या सुनावणीत कोणतेही दस्तऐवज संलग्न नाहीत",
  uploadAdditionalDocuments: "अतिरिक्त दस्तऐवज अपलोड करा",
  recentlyUploadedDocuments: "अलीकडे अपलोड केलेले दस्तऐवज",
  shareDetails: "तपशील शेअर करा",
  completedHearingDetails: "पूर्ण झालेल्या सुनावणीचे तपशील",
  caseInformation: "प्रकरणाची माहिती",
  hearingHistory: "सुनावणी इतिहास",
  hearingOutcome: "सुनावणीचा निकाल",
  finalVerdictDocument: "अंतिम निर्णय दस्तऐवज",
  officialDocument: "अधिकृत दस्तऐवज",
  finalVerdictPending: "अंतिम निर्णय दस्तऐवज प्रलंबित",
  caseDocuments: "प्रकरणाचे दस्तऐवज",
  finalVerdictLabel: "अंतिम निर्णय",

  SubmitFinalVerdict: "अंतिम निकाल सादर करा",
  FinalResolution: "अंतिम निराकरण",
  EnterDetailedObjectionInfo: "सविस्तर हरकतीची माहिती भरा",
  EnterFinalDecision: "या सुनावणीसाठी अंतिम निर्णय भरा...",
  EnterDocumentName: "दस्तऐवजाचे नाव भरा (उदा., पर्यावरण अहवाल, महसूल नोंद)",
  EnterDocumentDescription: "दस्तऐवजाचे वर्णन भरा",

  //LandHoldingList
  report: "अहवाल",
  appendix1: "परिशिष्ट 1",
  appendix2: "परिशिष्ट 2",
  appendix3: "परिशिष्ट 3",
  appendix6: "परिशिष्ट 6",
  selectAllToViewLandholding: "जमिनीचे तपशील पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा.",
  loadingAllLandholding: "सर्व जमिनीचे तपशील लोड होत आहेत...",
  loadingLandholding: "जमिनीचे तपशील लोड होत आहेत...",
  tryAdjustingSearch: "शोध समायोजित करण्याचा प्रयत्न करा",
  results: "निकाल",
  selectAllToViewData: "माहिती पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा",

  //LandTypeManagement
  AddNewLandType: "नवीन जमीन प्रकार जोडा",
  LoadingLandTypes: "जमिनीचे प्रकार लोड होत आहेत...",
  NoLandTypesFound: "तुमच्या निकषांशी जुळणारे कोणतेही जमिनीचे प्रकार आढळले नाहीत.",
  Entries: "नोंदी",
  CropPattern: "पीक पद्धत",
  //MeasurementList
  SideBarSection19: "कलम 19 ची घोषणा",
  NoMeasurements: "मोजमाप उपलब्ध नाही",
  SendVerifiedToLAOOfficer: "सत्यापित भूसंपादन अधिकाऱ्याकडे पाठवा",
  ReassignToSurveyor: "सर्व्हेयरकडे पुन्हा सोपवा",
  ReassignConfirmation: "आपण यापूर्वीच मोजमाप सर्व्हेयरकडे सोपवले आहे. आपण पुन्हा सर्व्हेयरकडे सोपवू इच्छिता का?",
  YesReassign: "होय, पुन्हा सोपवा",
  SelectDistrictNote: "मोजमाप डेटा पाहण्यासाठी कृपया किमान एक जिल्हा निवडा. आपण इच्छिल्यास तालुका आणि गाव देखील निवडू शकता.",
  ShowingAllMeasurements: "या प्रकल्पासाठी सर्व ठिकाणांमधील मोजमाप नोंदी दाखवत आहे.",
  LandHolderName: "भूधारकाचे नाव 7/12 नुसार",
  AquiredArea: "भूसंपादनासाठी प्रस्तावित क्षेत्र",
  Verification: "सत्यापन",
  AddDetails: "तपशील जोडा",
  LoadingMeasurements: "मोजमाप लोड होत आहेत...",
  AwaitingSurveyorCompletion: "सर्व्हेयरकडून पूर्ण होण्याची प्रतीक्षा",
  Verify: "सत्यापित करा",
  Verified: "सत्यापित",
  AddEdit: "जोडा/संपादित करा",
  NoMeasurementData: "निवडलेल्या फिल्टरसाठी कोणतेही मोजमाप डेटा सापडले नाही",
  DistrictSelectionRequired: "जिल्हा निवड आवश्यक",
  DistrictSelectionNote: "मोजमाप डेटा पाहण्यासाठी कृपया वर दिलेल्या फिल्टर पॅनेलमधून किमान एक जिल्हा निवडा.",
  SendToDSLROfficer: "DySLR अधिकाऱ्याकडे पाठवा",
  EnterRemarks: "टिप्पणी टाका...",
  DocumentView: "पहा",
  SendToDSLR: "DySLR अधिकाऱ्याकडे पाठवा",
  ProceedConfirmation: "आपण पुढे जाणार आहात",
  ProceedNote: "आपण खरोखर पुढे जाऊ इच्छिता का? अजून काही सर्व्हे सत्यापित केलेले नाहीत.",
  SendToSurveyor: "सर्व्हेयरकडे पाठवा",
  SelectUserSurveyor: "वापरकर्ता निवडा (सर्व्हेयर)",
  SendBackToDSLR: "DySLR अधिकाऱ्याकडे पाठवा",
  SelectUser: "वापरकर्ता निवडा",
  SendBackToDSLRText: "DSLR अधिकाऱ्याकडे परत पाठवा",
  SendToConcernValuer: "संबंधित मूल्यांकनकर्त्याकडे पाठवा",
  SelectConcernValuerUser: "संबंधित मूल्यांकनकर्ता वापरकर्ता निवडा",
  completing: "पूर्ण होत आहे...",
  loading_officers: "अधिकारी लोड होत आहेत...",
  select_officer: "अधिकारी निवडा",


  //MeasuementViseObjection
  MeasurementDetails: "मोजमाप तपशील",
  MeasuredArea: "मोजलेले क्षेत्र",
  ClaimedArea: "दावा केलेले क्षेत्र",
  SpecificObjections: "विशिष्ट हरकती",
  TreeObjectionDetails: "झाडांबाबत हरकतीचा तपशील",
  StructureObjectionDetails: "संरचनेबाबत हरकतीचा तपशील",
  WaterBodyObjectionDetails: "पाण्याच्या स्रोताबाबत हरकतीचा तपशील",
  OtherRemarks: "इतर टिप्पण्या",
  Attachments: "संलग्नक",
  AttachSurveyPlan: "सर्व्हे योजना जोडावी",
  UploadSurveyPlan: "सर्व्हे योजना अपलोड करा",
  MaxSurveyPlanSize: "(कमाल आकार: 1MB)",
  UploadPhotos: "फोटो अपलोड करा",
  MaxPhotoSize: "(कमाल आकार: प्रति फाइल 1MB, एकूण 5MB)",
  FilesUploaded: "फाइल(स) अपलोड झाल्या",
  Select: "निवडा",
  selectUserTehsildarOfficer:"वापरकर्ता निवडा तहसीलदार",

  //ObjectionList
  SearchObjections: "हरकती शोधा...",
  ShowingOfObjections: "हरकतींचे प्रदर्शन",
  SendToSLR: "एसएलआरकडे पाठवा",
  SelectUserSLR: "वापरकर्ता निवडा (एसएलआर)",
  SendToSLRButton: "एसएलआरकडे पाठवा",
  CreateObjection: "हरकत तयार करा",

  //PAP
  RehabilitationForm: "पुनर्वसन फॉर्म",
  DownloadPDF: "पीडीएफ डाउनलोड",
  SharePAPDetails: "पीएपी तपशील शेअर करा",
  PAPOwner: "पीएपी मालक:",
  Facebook: "फेसबुक",
  Twitter: "ट्विटर",
  WhatsApp: "व्हॉट्सअॅप",
  ShowAllRecords: "सर्व नोंदी दाखवा",
  SearchPAPs: "पीएपी शोधा...",
  SelectLocationMessage: "फिल्टर केलेले पीएपी डेटा पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा.",
  FilteredBy: "फिल्टर केलेले",
  TotalPAPs: "एकूण पीएपी",
  Average: "सरासरी",
  Paid: "दिले",
  AcquireArea: "अधिग्रहित क्षेत्र",
  FinalAmount: "अंतिम रक्कम",
  PaymentDate: "पेमेंट तारीख",
  PAPID: "पीएपी आयडी",
  ShowingToOfResults: "परिणाम दर्शवत आहे",
  SelectLocationToViewData: "फिल्टर केलेले डेटा पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा",
  NoPAPDataFound: "पीएपी डेटा सापडला नाही",
  NoProjectAffectedPersons: "सध्याच्या निकषांसाठी कोणताही प्रकल्प प्रभावित व्यक्ती सापडला नाही.",
  ClearSearch: "शोध साफ करा",
  NoProjectSelected: "कोणताही प्रकल्प/प्रस्ताव निवडलेला नाही",
  GoBackMessage: "कृपया डॅशबोर्डवर परत जा आणि प्रकल्प व प्रस्ताव निवडा",
  GoBackToDashboard: "डॅशबोर्डवर परत जा",
  InitializingPAPData: "PAP डेटा प्रारंभ करत आहे...",

  //PrivateObjection
  ok: "ठीक आहे",
  verifyYourEmail: "आपला ईमेल सत्यापित करा",
  otpSentMessage: "आम्ही तुमच्या ईमेलवर 6 अंकी ओटीपी पाठवला आहे",
  enterOtp: "ओटीपी प्रविष्ट करा",
  checkEmailForOtp: "कृपया आपला ईमेल तपासा आणि ओटीपी टाकून सबमिशन पूर्ण करा.",
  verifyOtp: "ओटीपी सत्यापित करा",
  dismiss: "रद्द करा",
  verifyOwnerDetails: "मालकाची माहिती सत्यापित करा",
  verify: "सत्यापित करा",
  objectionDate: "हरकत अर्ज दाखल केल्याची तारीख",
  enterYourName: "नाव प्रविष्ट करा",
  identityProofType: "ओळख पुराव्याचा प्रकार",
  representativeDetails: "प्रतिनिधीची माहिती (लागू असल्यास)",
  relationshipWithOwner: "मालकाशी नाते",
  measurementIssues: "मोजणीतील समस्या",
  treesAssessment: "झाडांचे मूल्यांकन",
  structuresAssessment: "रचनांचे मूल्यांकन",
  titleOwnershipIssues: "मालकीशी संबंधित समस्या",
  recordedArea: "नोंदवलेले क्षेत्र",
  recordedCompensation: "नोंदवलेली भरपाई (₹)",
  expectedCompensation: "अपेक्षित भरपाई (₹)",
  numberOfTreesRecorded: "नोंदवलेली झाडांची संख्या",
  numberOfTreesClaimed: "दावा केलेली झाडांची संख्या",
  charactersRemaining: "अक्षरे शिल्लक",

  //ProjectDetails
  LoadingProjectDetails: "प्रकल्प तपशील लोड होत आहे...",
  ProjectNotFound: "प्रकल्प सापडला नाही",
  ProjectNotFoundMessage: "विनंती केलेला प्रकल्प सापडला नाही",
  GoBack: "मागे जा",
  BackToProjects: "प्रकल्पांवर परत जा",
  Export: "निर्यात करा",
  ProjectProgress: "प्रकल्प प्रगती",
  Expected: "अपेक्षित",
  Parcels: "पार्सल",
  State: "राज्य",
  Coordinates: "निर्देशांक",
  ProjectBy: "प्रकल्प द्वारे",
  ProjectAreaBreakdown: "प्रकल्प क्षेत्राचा तपशील",
  PendingArea: "प्रलंबित क्षेत्रफळ",
  RoadLength: "रस्त्याची लांबी",
  ProjectTimeline: "प्रकल्प वेळापत्रक",
  ProjectStakeholders: "प्रकल्प हितधारक",
  ProjectImages: "प्रकल्पाच्या प्रतिमा",
  ProjectDocuments: "प्रकल्प कागदपत्रे",

  //ProjectManagemengt
  noProjectsFound: "कोणताही प्रकल्प सापडला नाही",
  adjustSearchCriteria: "शोध निकष किंवा फिल्टर सेटिंग्ज समायोजित करण्याचा प्रयत्न करा",
  clearFilters: "फिल्टर साफ करा",
  addNewProject: "नवीन प्रकल्प जोडा",
  division: "विभाग",
  acquisitionNo: "संपादन क्र.",
  orderNo: "आदेश क्र.",
  orderDate: "आदेश दिनांक",
  tehsil: "तालुका",
  noOfBudharak: "बुधारकांची संख्या",
  legacy: "Legacy",

  //Proposal
  loadingProposals: "प्रस्ताव लोड होत आहेत...",
  proposalManagement: "भूसंपादन प्रस्ताव",
  totalRecords: "एकूण नोंदी",
  proposalId: "प्रस्ताव आयडी",
  requiredAcquisitionArea: "आवश्यक अधिग्रहण क्षेत्र",
  exemption: "सवलत",
  publish: "प्रकाशित करा",
  noProposalsFound: "कोणतेही प्रस्ताव सापडले नाहीत",
  showingProposals: "प्रस्ताव दर्शवत आहे",
  clearSelection: "निवड साफ करा",
  addProposal: "प्रस्ताव तयार करा",
  searchProposals: "प्रस्ताव शोधा...",
  selectDistrictTalukaVillage: "प्रस्ताव डेटा पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा.",
  locationSelected: "स्थान निवडले",
  viewDataPrompt: "डेटा पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा",
  sendToSamanvay: "समन्वयाला पाठवा",
  sendingToSamanvay: "निवडलेले प्रस्ताव समन्वयाला पाठवत आहोत",
  selectSamanvayOfficerOption: "समन्वय अधिकारी निवडा",
  document: "दस्तऐवज",
  Send: "पाठवा",
  sendingToCollector: "निवडलेले प्रस्ताव कलेक्टरला पाठवत आहोत",
  selectCollector: "मा.कलेक्टर निवडा",
  trackingHistory: "ट्रॅकिंग इतिहास",
  noDocument: "दस्तऐवज नाही",
  noTrackingHistory: "ट्रॅकिंग इतिहास नाही",
  proposalNotProcessed: "हा प्रस्ताव अजून कोणत्याही टप्प्यातून गेला नाही.",
  lastUpdated: "शेवटचा अद्यतन",
  documentViewer: "दस्तऐवज दर्शक",
  openOriginal: "मूळ उघडा",
  failedToLoadImage: "प्रतिमा लोड करण्यात अयशस्वी",
  previewNotAvailable: "पूर्वावलोकन उपलब्ध नाही",
  cannotPreviewInBrowser: "या प्रकारचा दस्तऐवज ब्राउझरमध्ये पूर्वावलोकन करता येणार नाही",
  downloadAndOpen: "डाउनलोड करा आणि उघडा",

  //ProposalDetails
  LandAcquisitionProposal: "जमीन संपादन प्रस्ताव",
  AcquiredAgency: "संपादन संस्था",
  FileSelected: "फाइल निवडली",
  SubmitProposal: "प्रस्ताव सबमिट करा",
  AddLandAcquisitionProposal: "जमीन संपादन प्रस्ताव जोडा",
  ToBeAcquisitionLandArea: "संपादित करण्यात येणारे जमीन क्षेत्र",


  //ReportLandAcquisition
  loadingLandHoldings: "जमिनीच्या होल्डिंगची माहिती लोड करत आहे...",
  errorLoadingData: "डेटा लोड करताना त्रुटी",
  debugInformation: "डिबग माहिती:",
  selectedProject: "निवडलेला प्रकल्प",
  currentProjectId: "सध्याचा प्रकल्प आयडी",
  apiResponseDebug: "API प्रतिसाद डिबग",
  testApi: "API चाचणी",
  noDataAvailable: "कोणताही डेटा उपलब्ध नाही",
  noLandHoldingsFound: "या प्रकल्पासाठी कोणतीही जमिनीची होल्डिंग आढळली नाही",
  apiResponse: "API प्रतिसाद",
  downloadOptions: "डाउनलोड पर्याय",
  printPdf: "प्रिंट/PDF",
  ProjectKeys: "प्रोजेक्ट ऑब्जेक्ट की",


  //Reports
  ReportsGeneration: "अहवाल निर्मिती",
  ReportsDescription: "जमीन संपादन प्रकल्पांसाठी विविध अहवाल तयार करा",
  ReportType: "अहवाल प्रकार",
  Generating: "तयार होत आहे...",
  Preview: "पूर्वावलोकन",
  Downloading: "डाउनलोड होत आहे...",
  ReportPreview: "अहवाल पूर्वावलोकन",
  ClosePreview: "पूर्वावलोकन बंद करा",

  //RoleManagement
  Please_wait_while_we_fetch_the_user_data: "कृपया थांबा, आम्ही वापरकर्त्याची माहिती आणत आहोत",
  Select_Role: "भूमिका निवडा",
  Assigned_Projects_and_Proposals: "नियुक्त प्रकल्प आणि प्रस्ताव",
  searchuserproject: "वापरकर्ते किंवा प्रकल्प शोधा...",
  SearchUsername: "वापरकर्तानाव शोधा",


  //Searchbar
  projectRequired: "प्रकल्प आवश्यक",
  selectProjectSearch: "शोध कार्यासाठी कृपया प्रकल्प निवडा.",
  landRecordsSearch: "जमीन अभिलेख शोध",
  landRecordsSearchDesc: "जमीन अभिलेख शोधा आणि व्यवस्थापित करा",
  searchFilters: "शोध फिल्टर्स",
  enterName: "नाव टाका",
  surveyGatNumber: "सर्व्हे/गट क्रमांक",
  enterSurveyGatNumber: "सर्व्हे/गट क्रमांक टाका",
  selectDistrictTalukaFirst: "प्रथम जिल्हा व तालुका निवडा",
  clearAll: "सर्व साफ करा",
  searchingRecords: "नोंदी शोधत आहोत...",
  searchError: "शोध त्रुटी",
  searchResults: "शोध परिणाम",
  Found: "सापडले",
  noRecordsFound: "नोंदी आढळल्या नाहीत",
  clearSearch: "शोध साफ करा",
  readyToSearch: "शोधण्यासाठी तयार",
  enterCriteria: "जमीन अभिलेख शोधण्यासाठी वर कोणतेही शोध निकष भरा",
  nameShort: "नाव",
  mobileShort: "मोबाईल",
  surveyNoShort: "सर्व्हे  क्र.",
  districtShort: "जिल्हा",
  talukaShort: "तालुका",
  villageShort: "गाव",

  //UserManagement
  searchuser: "वापरकर्ते शोधा...",
  users: "वापरकर्ते",
  addNewUser: "नवीन वापरकर्ता जोडा",
  projectManagerCoordinator: "प्रकल्प व्यवस्थापक / समन्वयक",
  surveyor: "सर्वेक्षक",
  collector: "कलेक्टर",
  verifier: "सत्यापनकर्ता",

  //UserProfile
  loadingProfile: "प्रोफाइल लोड होत आहे",
  fetchingLatestInfo: "आपली ताजी माहिती आणत आहे...",
  complete: "पूर्ण",
  manageAccountPreferences: "आपले खाते आणि प्राधान्ये व्यवस्थापित करा",
  themeColors: "थीम रंग",
  notifications: "सूचना",
  privacy: "गोपनीयता",
  exportJson: "JSON निर्यात करा",
  profileCompletion: "प्रोफाइल पूर्णता",
  profile: "प्रोफाइल",
  skillsExperience: "कौशल्ये आणि अनुभव",
  achievements: "उपलब्धी",
  analytics: "विश्लेषण",
  security: "सुरक्षा",
  dropImageHere: "येथे प्रतिमा सोडा",
  binaryImageData: "बायनरी प्रतिमा डेटा",
  filename: "फाइल नाव",
  online: "ऑनलाइन",
  experience: "अनुभव",
  rating: "रेटिंग",
  bio: "जीवनी",
  socialLinks: "सामाजिक दुवे",
  github: "गिटहब",
  linkedin: "लिंक्डइन",
  twitter: "ट्विटर",
  enterDistrict: "जिल्हा भरा",
  professionalInfo: "व्यावसायिक माहिती",
  designation: "हुद्दा",
  department: "विभाग",
  binaryStorageEnabled: "बायनरी संचयन सक्षम",
  saving: "जतन करत आहे...",
  skillsTechnologies: "कौशल्ये आणि तंत्रज्ञान",
  experienceOverview: "अनुभव आढावा",
  totalExperience: "एकूण अनुभव",
  yearsInField: "क्षेत्रातील वर्षे",
  projectsCompleted: "पूर्ण प्रकल्प",
  successfulDeliveries: "यशस्वी वितरण",
  clientRating: "ग्राहक रेटिंग",
  avgFeedbackScore: "सरासरी अभिप्राय गुण",
  achievementsRecognition: "उपलब्धी आणि मान्यता",
  profileAnalytics: "प्रोफाइल विश्लेषण",
  profileViews: "प्रोफाइल दृश्ये",
  profileShares: "प्रोफाइल शेअर्स",
  connections: "संपर्क",
  growthMetrics: "वाढ मोजमाप",
  ProfileCompletion: "प्रोफाइल पूर्ण",
  securitySettings: "सुरक्षा सेटिंग्ज",
  twoFactorAuth: "दुहेरी प्रमाणीकरण",
  addExtraSecurity: "आपल्या खात्यात अतिरिक्त सुरक्षा जोडा",
  enable2FA: "2FA सक्षम करा",
  loginHistory: "लॉगिन इतिहास",
  viewRecentLogin: "आपली अलीकडील लॉगिन क्रियाकलाप पहा",
  viewHistory: "इतिहास पहा",
  privacySettings: "गोपनीयता सेटिंग्ज",
  managePrivacy: "गोपनीयता व्यवस्थापित करा",
  manageprofile: "तुमची प्रोफाइल माहिती कोण पाहू शकते ते व्यवस्थापित करा",
  profileQRCode: "प्रोफाइल QR कोड",
  scanToViewProfile: "प्रोफाइल पाहण्यासाठी स्कॅन करा",
  deleteProfileImage: "प्रोफाइल प्रतिमा हटवा",
  confirmDeleteProfileImage: "आपण आपली प्रोफाइल प्रतिमा नक्की हटवू इच्छिता?",
  WelcomeMessage: "माझ्या प्रोफाइलवर आपले स्वागत आहे! मला तंत्रज्ञान आणि नवकल्पनांची आवड आहे.",

  //ViewMeasurementList
  loadingMeasurementDetails: "मापन तपशील लोड होत आहेत...",
  noMeasurementData: "मापन डेटा उपलब्ध नाही",
  confirmDownload: "डाउनलोडची पुष्टी करा",
  confirmDownloadMessage: "आपण खरोखर मापन अहवाल डाउनलोड करू इच्छिता?",
  occupantsManagement: "भोगवटाधारक व्यवस्थापन",
  addOrManageOccupants: "मालमत्तेचे भोगवटाधारक जोडा किंवा व्यवस्थापित करा",
  addNewOccupantName: "नवीन भोगवटाधारकाचे नाव जोडा",
  gatNo: "गट क्र.",
  hrm: "एच.आर.एम.",
  areaAfterCounterAcquisition: "काउंटर-जमीन अधिग्रहण गणनेनंतर अधिग्रहित होणारे क्षेत्र",
  actualOccupantNames: "प्रत्यक्ष भोगवटाधारक नावे",
  jointCalculationTools: "संयुक्त गणना साधनांनुसार",
  irrigative: "सिंचित",
  nonIrrigative: "असिंचित",
  akoom: "अकूम",
  tree: "झाड",
  crops: "पिके",
  tinshedGodown: "टिनशेड/गोदाम",
  wellLake: "विहीर, शेव तलाव",
  borewell: "बोअरवेल",
  wireFence: "तार कुंपण",
  occupantSummary: "भोगवटाधारक सारांश",
  contactNo: "संपर्क क्रमांक",
  totalOccupantPortion: "एकूण भोगवटाधारकाचा हिस्सा",
  occupantLandPortion: "भोगवटाधारकाचा जमिनीचा हिस्सा",
  occupantVerificationCompensation: "भोगवटाधारक पडताळणी आणि भरपाई",
  compensationDetails: "भरपाई तपशील",
  totalPercentage: "एकूण टक्केवारी",
  identityVerification: "ओळख पडताळणी",
  assetCompensationDetails: "मालमत्ता भरपाई तपशील",
  noOfTinshed: "टिनशेडची संख्या",
  noOfWellLakeShev: "विहीर/तलाव/शेव यांची संख्या",

  Default : "डीफॉल्ट",
  Setdefault : "डीफॉल्ट सेट करा"  ,
 
  documentManagement: "दस्तऐवज व्यवस्थापन",
  viewImages: "प्रतिमा पहा",
  uploadNewFiles: "नवीन फाइल्स अपलोड करा",
  supportedFileTypes: "PDF, JPG, PNG, DOC, DOCX फाइल्स (अनेक फाइल्स समर्थित)",
  filesToUpload: "अपलोड करण्यासाठी फाइल्स",
  imagePreviews: "प्रतिमा पूर्वावलोकन",
  image: "प्रतिमा",
  uploading: "अपलोड होत आहे...",
  uploadedSuccessfully: "फाइल्स यशस्वीरित्या अपलोड झाल्या",
  totalFiles: "एकूण फाइल्स",
  uploadedFiles: "अपलोड केलेल्या फाइल्स",
  zoom: "झूम",

  //VillageManagement
  searchVillages: "गावे, तालुका, जिल्हा शोधा...",
  show: "दाखवा",
  commonCauses: "सामान्य कारणे",
  apiServiceIssues: "एपीआय सेवा संरचना समस्या",
  serverNotResponding: "सर्व्हर चालू नाही किंवा प्रतिसाद देत नाही",
  authTokenExpired: "प्रमाणीकरण टोकन कालबाह्य झाले",
  networkIssues: "नेटवर्क कनेक्टिव्हिटी समस्या",
  clearSearchResults: "शोध परिणाम साफ करा",
  villagedata: "गाव डेटा डाउनलोड करा",


  //GeneralObjection
  OK: "ठीक आहे",
  VerifyYourEmail: "आपला ईमेल सत्यापित करा",
  Wevesent6digitOTPto: "आम्ही 6-अंकी OTP पाठवले आहे",
  EnterOTP: "OTP प्रविष्ट करा",
  PleasecheckyouremailandenterOTPtocomplete: "कृपया आपला ईमेल तपासा आणि सबमिशन पूर्ण करण्यासाठी OTP प्रविष्ट करा.",
  VerifyOTP: "OTP सत्यापित करा",
  FilePreview: "फाइल पूर्वदर्शन",
  PDFDocument: "PDF दस्तऐवज",
  OpenInNewTab: "नवीन टॅबमध्ये उघडा",
  Filetypenotsupportedforpreview: "पूर्वदर्शनासाठी फाइल प्रकार समर्थित नाही",
  Dismiss: "रद्द करा",
  ObjectorDetails: "अर्जदाराचे तपशील",
  EnterYourName: "आपले नाव प्रविष्ट करा",
  UploadIdentityProof: "ओळख प्रमाणपत्र अपलोड करा",
  MaxSize256KB: "(कमाल आकार: 256KB)",
  UploadSupportingDocument: "सहाय्यक दस्तऐवज अपलोड करा",
  OptionalMaxSize256KB: "(ऐच्छिक - कमाल आकार: 256KB)",
  UploadAnyAdditionalDocuments: "तुमच्या तक्रारीला आधार देणारे कोणतेही अतिरिक्त दस्तऐवज अपलोड करा (उदा. मालमत्ता कागदपत्रे, पावत्या, छायाचित्रे)",
  SupportingDocumentUploaded: "सहाय्यक दस्तऐवज अपलोड झाला",
  EnvironmentalConcerns: "पर्यावरणीय चिंता",
  ResettlementIssuesLack: "पुनर्वसन समस्या",
  ReligiousCulturalSites: "धार्मिक/सांस्कृतिक स्थळे",
  TitleOwnershipIssues: "टायटल/मालकी हक्क समस्या",
  PublicInterest: "सार्वजनिक हित",
  OtherObjectionPleaseSpecify: "इतर तक्रार (कृपया नमूद करा)",
  NumberOfTreesRecorded: "नोंदवलेली झाडांची संख्या",
  NumberOfTreesClaimed: "दावा केलेली झाडांची संख्या",
  TreeDetailsSpeciesAgeEtc: "झाड तपशील (प्रजाती, वय, इत्यादी)",
  SubmitObjection: "तक्रार सादर करा",
  CharactersRemaining: "शिल्लक वर्ण",
  Matter: "बाब",
  AppointLandSurveyor: "भुकरमापक नेमणे",
  landAcquisitionAuthorityEcounting: "भूसंपादन यंत्रणेने ई मोजणी प्रणालीत अर्ज केल्याचा  दिनांक ",
  feeCollectedByLandAcquisition: "भूसंपादन यंत्रणेने मोजणी प्रक्रियेसाठी शासन जमा केलेली फी ",
  DatePaymentFeeCollected: "भूसंपादन यंत्रणेने मोजणी प्रक्रियेसाठी फी भरल्याचा दिनांक",
  JointCensudDate: "संयुक्त मोजणीचा दिनांक ",
  JointRepresentatives: "संयुक्त मोजणी वेळी उपस्थितीत यंत्रणा प्रतिनिधींचे नाव, पदनाम ",
  GeoTaggedPhoto: "उपस्थित अधिकारी कर्मचारी यांचा जियोटॅग फोटो",
  MRNo: "मो. र. क्रमांक",
  BhusampadanNo: "भूसंपादन प्रकरण क्रमांक",
  PurposeOfLandAcquisition: "भूमी संपादनाचे प्रयोजन",
  Section21_1: "कलम 21(1)",
  Section21: "जाहिरनामा",
  SidebarSection21_1: "कलम 21 ची कार्यवाही",
  SidebarSection21_1_4: "कलम 21_1_4 ची कार्यवाही",
  Section21_1_4: "कलम 21(1)(4)",
  UnderSection21: "कलम २१नुसार दाखल दाव्यांचा तपशील",

  Workersjudgment: "निवाडा पश्यात कामकाज",
  //EditOwner
  valid: "वैध",
  document_status: "कागदपत्र स्थिती",
  file_name: "फाईल नाव",
  edit_property_occupant: "मालमत्ता धारक संपादित करा",
  property_details: "मालमत्तेचे तपशील",
  land_ownership_compensation: "जमिनीचे मालकी हक्क आणि भरपाई तपशील",
  total_remaining: "एकूण उर्वरित",
  acquired_area: "संपादन केलेले क्षेत्र",
  acquired_remaining: "उर्वरित संपादन",
  total_land_portion: "एकूण जमीन हिस्सा",
  must_be_less_total_land: "≤ एकूण क्षेत्र असणे आवश्यक आहे",
  required_land_portion: "आवश्यक जमीन हिस्सा",
  must_be_less_total_occupant: "≤ एकूण धारक हिस्सा असणे आवश्यक आहे",
  land_category: "जमिनीचा प्रकार",
  and_less_remaining_acquisition: "आणि ≤ उर्वरित संपादन क्षेत्र",
  select_category: "प्रकार निवडा",
  mixed_use: "मिश्र वापर",
  property_assets: "मालमत्ता संपत्ती",
  trees: "झाडे",
  select_tree_type: "झाडाचा प्रकार निवडा",
  add_tree: "झाड जोडा",
  trees_plural: "झाडे",
  homes: "घरे",
  residential_structures: "निवासी रचना",
  saved: "जतन केले",
  home: "घर",
  permanent_house: "पक्के घर",
  temporary_house: "तात्पुरते घर",
  ground: "जमीन",
  first_floor: "पहिला मजला",
  second_floor: "दुसरा मजला",
  third_floor: "तिसरा मजला",
  floor: "मजला",
  add_home: "घर जोडा",
  tin_sheds: "टिन शेड",
  industrial_structures: "औद्योगिक रचना",
  wire_fencing: "तार कुंपण",
  boundary_structures: "सीमा रचना",
  fence: "कुंपण",
  pipe: "पाईप",
  add_fence: "कुंपण जोडा",
  farm_ponds: "शेती तलाव",
  water_reservoirs: "जलाशय",
  dimension: "आकार",
  wells: "विहिरी",
  borewells: "बोअरवेल",
  water_pipeline: "पाणी पाईपलाईन",
  occupant_information: "धारक माहिती",
  basic_details_occupant: "मालमत्ता धारकाची मूलभूत माहिती",
  occupant_name: "धारकाचे नाव",
  contact_number: "संपर्क क्रमांक",
  occupant_type: "धारकाचा प्रकार",
  select_occupant_type: "धारकाचा प्रकार निवडा",
  joint_occupant: "संयुक्त धारक",
  company_corporation: "कंपनी/निगम",
  email_address: "ईमेल पत्ता",
  complete_address: "पूर्ण पत्ता",
  location_information_media: "स्थान माहिती आणि मीडिया",
  gps_coordinates: "जीपीएस निर्देशांक",
  longitude: "रेखांश",
  getting_location: "स्थान मिळवत आहे...",
  get_current_location: "सध्याचे स्थान मिळवा",
  view_on_map: "नकाशावर पहा",
  property_media_files: "मालमत्ता मीडिया फाईल्स",
  upload_property_media: "दस्तऐवज आणि पडताळणीसाठी मालमत्तेचे फोटो आणि व्हिडिओ अपलोड करा",
  save_changes: "बदल जतन करा",
  AddPond: "तलाव जोडा",
  Sheds: "शेड",
  Fences: "कंपण",
  Ponds: "तलाव",
  LocationMedia: "स्थान आणि माध्यम",
  Uploaded: "अपलोड केले",
  PropertyImage: "मालमत्तेचा फोटो",
  PropertyVideo: "मालमत्तेचा व्हिडिओ",
  NoFileSelected: "कोणतीही फाईल निवडलेली नाही",

  // MR-----------------------------------------------------------------------
  // PublishProposal
  SendToSamanvayOfficerExtendDate: "समन्वय अधिकार्यांना पाठवा",
  SendToCollectorExtendDate: "मा.जिल्हाधिकाऱ्यांकडे पाठवा",
  SendBackToLAOExtendDate: "भूसंपादन अधिकार्यांना पाठवा",
  LoadingProposalData: "प्रस्ताव डेटा लोड होत आहे...",
  AlreadySentToSamanvay: "आधीच समन्वय कार्यालयाला पाठवले आहे",
  ConfirmResubmission: "पुन्हा सादर करण्याची पुष्टी करा",
  AlreadySentOnce: "आपण आधीच एकदा पाठवले आहे. पुन्हा पाठवू इच्छिता?",
  PublicationPreliminaryNotification: "प्रारंभिक अधिसूचना प्रसिद्धी",
  AlreadySentBackToLAO: "आधीच एलएओकडे परत पाठवले आहे",
  PreliminaryNotificationSection11: "प्रारंभिक अधिसूचना",
  ProposalDetails: "भूसंपादन प्रकरण तपशील",
  NotPublish: "प्रकाशित नाही",
  BhusampadanNumber: "भूसंपादन क्र.",
  Exemption: "सूट",
  PublishedNewspaper: "प्रकाशित वृत्तपत्र",
  Section11Date: "प्रारंभिक अधिसूचना तारीख",
  Setion11PublicationDate: "प्रारंभिक अधिसूचना प्रसिद्धी तारीख",
  Section11OneYearDate: "भूसंपादन प्रकरण व्यपगत दिनांक",
  Published: "प्रकाशित",
  PublicationDetails: "प्रकाशन तपशील",
  PublicationNo: "प्रकाशन क्र.",
  PublicationDate: "प्रकाशन तारीख",
  NotPublishedMessage: "प्रकाशित नाही - हा प्रस्ताव प्रकाशित करण्यासाठी प्रकाशित बटण वापरा",
  AdministrativeOrderDate: "प्रशासनिक आदेश दिनांक",
  AreaFinancialDetails: "क्षेत्र आणि आर्थिक तपशील",
  NoOfLandParcels: "जमिनीच्या तुकड्यांची संख्या",
  ProposalAmount: "प्रस्ताव रक्कम",
  ExemptionDetails: "सूट तपशील",
  ExemptionFile: "सूट फाइल",
  NoFileAvailable: "कोणतीही फाइल उपलब्ध नाही",
  // --------------------------
  OfficeofPublication: "प्रसिद्धीचे कार्यालय/ठिकाण",
  DateofPublication: "प्रसिद्ध केल्याचा दिनांक",
  Documents: "दस्तऐवज",
  GovernmentGazette: "शासन राजपत्र",
  Newspaper1: "वर्तमान पत्र - १",
  Newspaper2: "वर्तमान पत्र - २",
  MunicipalCorporation: "स्थानिक ग्रामपंचायत/नगरपालिका/महानगरपालिका",
  DistrictCollectorOffice: "जिल्हाधिकारी कार्यालय",
  SubDivisionalOfficer: "उपविभागीय अधिकारी/दंडाधिकारी कार्यालय",
  TehsilOffice: "तहसील कार्यालय",
  GovernmentNoticeBoard: "समुचित शासनाचे संकेतस्थळ",
  GramSevakOffice: "ग्राम महसूल अधिकारी कार्यालय",
  GramSevakOffice1: "ग्राम महसूल अधिकारी कार्यालय",
  GramPanchayatOffice: "ग्रामपंचायत कार्यालय",
  PreliminaryNotificationunderRule10: "भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क (महाराष्ट्र) नियम, 2014 च्या नियम 10 च्या उप नियम (2) नुसार प्रारंभिक अधिसूचनेचा प्रसिद्धी दिनांक",
  dateOfNotificationUnderColumn19: "कलम 19 खालील घोषणेचा प्रसिद्धी",
  No:"क्रमांक",

  Proceeding: "कार्यवाही",
  AdministrativeOrder: "प्रशासनिक आदेश",
  Publication: "प्रकाशन",
  AcquisitionProposal: "भूसंपादन प्रस्ताव",
  AppointedAdministrator: "नियुक्त प्रशासक",
  PublishedGazette: "प्रकाशित राजपत्र",
  SelectUserDSLR: "वापरकर्ता निवडा (DySLR)",
  SendToLAOOfficer: "भूसंपादन अधिकाऱ्याला पाठवा",
  SelectUserLAO: "वापरकर्ता निवडा (भूसंपादन अधिकारी)",
  SendBackToLAOOfficer: "एलएओकडे परत पाठवा",
  SelectUserCollector: "मा.जिल्हाधिकारी",
  EnterAdministrativeOrderNumber: "प्रशासनिक आदेश क्रमांक प्रविष्ट करा",
  EnterPublicationNumber: "प्रकाशन क्रमांक प्रविष्ट करा",
  EnterAcquisitionProposalNumber: "संपादन प्रस्ताव नाव प्रविष्ट करा",
  EnterAdministratorName: "प्रशासकाचे नाव प्रविष्ट करा",
  Publishing: "प्रकाशित केले जात आहे...",
  ViewDetail: "तपशील पाहा",
  HideDetail: "तपशील लपवा",
  PublishProposal: "प्रस्ताव प्रकाशित करा",
  ThroughSection11: "कलम 11 द्वारे",
  EnterAdministrativeOrderNo: "प्रशासकीय आदेश क्रमांक प्रविष्ट करा",
  EnterPublicationNo: "प्रकाशन क्रमांक प्रविष्ट करा",
  EnterAcquisitionProposalNo: "संपादन प्रस्ताव नाव प्रविष्ट करा",
  EnterProceedingNo: "कार्यवाही क्रमांक प्रविष्ट करा",
  AlreadySentToDSLRClickToResend: "डीएसएलआरकडे आधीच पाठवले आहे. पुन्हा पाठवण्यासाठी क्लिक करा.",
  PublishProposalSendToDSLROfficer: "संयुक्त मोजणीसाठी पाठवा",
  SuccessfullySentToDSLROfficer: "DySLR अधिकाऱ्याला यशस्वीरित्या पाठवले!",

  // Extend Date
  LoadingExtendDate: "दिनांक वाढवा डेटा लोड होत आहे...",
  ExtensionDate: "वाढीव दिनांक",
  NoExtensions: "दिनांक वाढवा उपलब्ध नाही",
  Extend: "वाढवा",

  // Section -11 Prathmik Adhisuchna
  LoadingPrambhikAdhisuchna: "प्रारंभिक अधिसूचना लोड करत आहे...",
  EditProposal: "प्रारंभिक अधिसूचना दुरस्ती",
  ProposalDetail: "भूसंपादन प्रकरण तपशील",
  EnterBhusampadanNumber: "भूसंपादन क्रमांक प्रविष्ट करा",
  BhusampadanDate: "दिनांक",
  EnterMobileNo: "दूरध्वनी क्रमांक प्रविष्ट करा",
  OfficeName: "कार्यालयाचे नाव",
  EnterOfficeName: "कार्यालयाचे नाव प्रविष्ट करा",
  EnterBranchName: "शाखेचे नाव प्रविष्ट करा",
  ResendCancelled: "रद्द केलेले पुन्हा पाठवा",
  AlreadySentToSamanvayOfficerClickToResend: "समन्वय अधिकाऱ्याला आधीच पाठवले आहे. पुन्हा पाठवण्यासाठी क्लिक करा.",
  AlreadySentToCollectorClickToResend: "कलेक्टरकडे आधीच पाठवले आहे. पुन्हा पाठवण्यासाठी क्लिक करा.",
  AlreadySentBackToLAOClickToResend: "भूसंपादन अधिकारी कडे आधीच परत पाठवले आहे. पुन्हा पाठवण्यासाठी क्लिक करा.",
  selectUserSamanvayOfficer: "समन्व्य अधिकारी",
  SuccessfullySentToSamanvayOfficer: "समन्वय अधिकाऱ्याला यशस्वीरित्या पाठवले!",
  SuccessfullySentToCollectorOfficer: "मा.जिल्हाधिकारी अधिकाऱ्याला यशस्वीरित्या पाठवले!",
  SuccessfullySentToLAOOfficer: "भूसंपादन अधिकाऱ्याला यशस्वीरित्या पाठवले!",

  // Section19
  LoadingSection19: "कलम 19 लोड करत आहे...",
  Section19Publication: "कलम 19 प्रसिद्धी",
  Section19UpdatedSuccessfully: "कलम 19 यशस्वीरित्या अद्ययावत झाले.",
  Section19PublishedSuccessfully: "कलम 19 ची यशस्वीरित्या प्रसिद्धी करण्यात आली आहे.",

  //Section15
  Section15: "कलम 15",
  Section15Notice: "कलम 15 नोटीस ",
  S15Email: "ई-मेल",
  S15Phone: "दूरध्वनी क्रमांक",
  S15FileNumber: "कार्यविवरण क्रमांक",
  S15Date: "तारीख",
  S15RecipientDetails: "प्राप्तकर्ता तपशील",
  S15MainContent: "तपशील",

  //Undersection 21
  AdSrNo: "अ.क्र.",
  AdLandholderName: "भूधारकाचे नाव",
  AdSurveyNumber: "गट/सर्व्हे क्रमांक",
  AdVillage: "गाव",
  AdTotalArea: "एकूण क्षेत्र (हे.आर.)",
  AdAdvanceAmount: "अग्रिमाची रक्कम",
  AdSanctionDate: "प्रदानाचा दिनांक",
  AdAction: "क्रिया",
  AdApprovalDate: "मंजुरी आदेश दिनांक",
  ClaimantName: "दावा दाखल करणाऱ्याचे नाव",
  Address21: "पत्ता",
  ClaimFilingDate: "दावा भूसंपादन अधिकारी यांच्या समोर दाखल केल्याची तारीख",
  ClaimGroupNumber: "दाव्याचा गट क्रमांक",
  ClaimDetails: "दाव्यातील तपशील",
  ClaimsUnderSection21: "कलम 21 अंतर्गत दावे",
  LAODecisionStatus: "भूसंपादन अधिकार्‍यांचा निर्णय स्थिती",
  Proceedings: "कार्यवाही",
  Print21: "प्रिंट",
  AddNewClaim: "नवीन दावा जोडा",
  LoadingClaims: "दावे लोड होत आहेत...",
  CommentAvailable: "टिप्पणी उपलब्ध",
  NoClaimsFound: "कलम 21 अंतर्गत कोणतेही दावे आढळले नाहीत",
  Documents21: "दस्तऐवज",
  Cancel21: "रद्द करा",
  Adding21: "जोडले जात आहे...",
  AddClaim: "दावा जोडा",
  SrNo21: "अ.क्र",
  Section21ClaimDetails: "कलम 21 अंतर्गत दाव्याचा तपशील",
  MainInfo: "मुख्य माहिती",
  Status21: "स्थिती",
  Decision21: "निर्णय",
  SelectDecision: "निर्णय निवडा",
  Approved: "मान्य",
  StatusRejected: "अमान्य",
  DecisionDate: "निर्णय दिनांक",
  LAOComment: "भूसंपादन अधिकार्‍यांचा टिप्पणी",
  EnterDecisionReason: "निर्णयाचा कारण आणि सविस्तर टिप्पणी लिहा...",
  AdditionalDetails: "अतिरिक्त माहिती",
  NotAvailable: "उपलब्ध नाही",
  LoadingProjectInfo: "प्रोजेक्टची माहिती लोड होत आहे...",
  Close21: "बंद करा",
  LastUpdated21: "अंतिम अद्यतन",
  View21: "पहा",
  SaveDecision: "निर्णय जतन करा",
  Processing21: "प्रक्रिया सुरू आहे...",
  CompleteClaimInfo: "पूर्ण दावा माहिती आणि भूसंपादन अधिकारी निर्णय",
  Complete21: "पूर्ण",
  Pending21: "प्रलंबित",
  GiveLAODecision: "भूसंपादन अधिकारी निर्णय द्या",
  Date21: "दिनांक",

  //Market Value
  MarketGatNumber: "गट क्रमांक",
  EligibleArea: "लागवड योग्य क्षेत्र (हे. आर)",
  DeductionReason: "गटाची आकारणी (रु.पै.)",
  HectareDeduction: "हेक्टरी आकारणी (रु.पै.)",
  AreaGat: "आकार गट",
  HectareRate: "निश्चित केलेला हेक्टरी दर",
  MarketPriceChart: "आकार गट - हेक्टरी दर तक्ता",
  MarketAction: "कार्यवाही",
  LoadingMarketPrices: "बाजारभाव लोड होत आहेत...",

  // Compensation
  loadingCompensationData: "भरपाई डेटा लोड होत आहे",
  pleaseWaitCompensation: "कृपया प्रतीक्षा करा, आम्ही भरपाई तपशील आणत आहोत...",
  landOwnerId: "भूधारक आयडी",
  currency: "चलन",
  inr: "INR",
  usd: "USD",
  eur: "EUR",
  compensationStatus: "भरपाई स्थिती",
  rejected: "नाकारले",
  landValuation: "जमीन मूल्यांकन", 
  valuationDate: "मूल्यांकन तारीख",
  assetValues: "मालमत्ता मूल्य",
  interestRate: "व्याज दर",
  interestAmount: "व्याजाची रक्कम",
  additionalCompensation: "अतिरिक्त भरपाई",
  AdditionalAmount: "अतिरिक्त रक्कम",
  reasonAdditionalCompensation: "अतिरिक्त भरपाईचे कारण",
  approvalPaymentInformation: "मंजूरी व पेमेंट माहिती",
  approvalDate: "मान्यता तारीख",
  approvalAuthority: "मान्यता प्राधिकरण",
  approvalReference: "मंजूरी संदर्भ",
  paymentMode: "पेमेंट पद्धत",
  paymentReference: "पेमेंट संदर्भ",
  paymentRemarks: "पेमेंट टिपण्णी",
  consentDate: "संमतीची तारीख",
  consentReceived: "भूमिधारकाकडून संमती मिळाली",
  totalCompensationAmount: "एकूण भरपाई रक्कम",
  calculatedTotal: "सर्व घटकांचा समावेश असलेली एकूण गणना",
  autoCalculated: "स्वयंचलित गणना",
  manualOverride: "मॅन्युअल एकूण भरपाई ओव्हरराईड",
  submitCompensationForm: "भरपाई फॉर्म सबमिट करा",
  LoadingPaymentData: "पेमेंट डेटा लोड होत आहे",
  FinalAmountToBePaid: "देय अंतिम रक्कम",
  PaidFromBankIFSC: "बँक IFSC मधून पेमेंट",
  PaidFromAccountNo: "खाते क्रमांकातून पेमेंट",
  SubmitPaymentDetails: "पेमेंट तपशील सबमिट करा",
  EnterBankName: "बँकेचे नाव प्रविष्ट करा",
  EnterAccountNumber: "खाते क्रमांक प्रविष्ट करा",
  EnterIFSCCode: "IFSC कोड प्रविष्ट करा",
  EnterAccountHolderName: "खातेदाराचे नाव प्रविष्ट करा",
  EnterPayingBankIFSC: "पेमेंट करणाऱ्या बँकेचा IFSC प्रविष्ट करा",
  EnterPayingAccountNumber: "पेमेंट करणारा खाते क्रमांक प्रविष्ट करा",
  EnterLandOwnerID: "जमीन मालक आयडी प्रविष्ट करा",
  EnterRatePerUnit: "प्रति युनिट दर प्रविष्ट करा",
  EnterTotalLandValue: "एकूण जमिनीचे मूल्य प्रविष्ट करा",
  EnterStructureValue: "संरचनेचे मूल्य प्रविष्ट करा",
  EnterTreeValue: "झाडांचे मूल्य प्रविष्ट करा",
  EnterCropValue: "पिकाचे मूल्य प्रविष्ट करा",
  EnterWaterBodyValue: "जलाशयाचे मूल्य प्रविष्ट करा",
  EnterOtherAssetValue: "इतर मालमत्तेचे मूल्य प्रविष्ट करा",
  EnterSolatiumPercentage: "सोलॅटियम टक्केवारी प्रविष्ट करा",
  EnterSolatiumAmount: "सोलॅटियम रक्कम प्रविष्ट करा",
  EnterInterestRate: "व्याजदर प्रविष्ट करा",
  EnterInterestAmount: "व्याजाची रक्कम प्रविष्ट करा",
  EnterAdditionalCompensation: "अतिरिक्त भरपाई प्रविष्ट करा",
  EnterReasonForAdditionalCompensation: "अतिरिक्त भरपाईचे कारण प्रविष्ट करा",
  EnterPaymentReference: "पेमेंट संदर्भ प्रविष्ट करा",
  EnterPaymentRemarks: "पेमेंट टिप्पण्या प्रविष्ट करा",
  EnterApprovalAuthority: "मंजुरी प्राधिकारी प्रविष्ट करा",
  EnterApprovalReference: "मंजुरी संदर्भ प्रविष्ट करा",
  EnterTotalCompensationAmount: "एकूण भरपाईची रक्कम प्रविष्ट करा",
  ManualTotalCompensationOverride: "मॅन्युअल एकूण भरपाई अधिलेखन",
  NatureOfOwner: "मालकी हक्काचा प्रकार",
  ActualOccupant: "प्रत्यक्ष भोगवटाधारक",

  // Compensation Amount
  GatNumber: "गट नं.",
  areaOfSurvey: "सर्व्हे क्षेत्रफळ",
  totalAreaOfSurvey: "एकूण सर्व्हे क्षेत्र",
  areaAcquired: "संपादित क्षेत्र ",
  compensationCount: "भरपाई संख्या",
  compLand: "जमीन",
  compStructure: "इमारत",
  compTree: "झाडे",
  compOthers: "इतर",
  compTotal: "एकूण",
  solatium: "सांत्वन",
  custom: "सानुकूल",
  rateAmountDisabled: "मोजणी उपलब्ध नसल्यामुळे दर आणि रक्कम अकार्यान्वित आहेत",
  loadingCompensation: "भरपाई माहिती लोड होत आहे...",
  ownersSelected: "मालक निवडले",
  sendToFinalAward: "अंतिम मंजुरीसाठी पाठवा",
  selectLocationNotice: "कृपया भरपाई डेटा पाहण्यासाठी जिल्हा, तालुका आणि गाव निवडा.",
  selectFromFilter: "कृपया वरील फिल्टर पॅनलमधून जिल्हा, तालुका आणि गाव निवडा.",
  editCompensationRecord: "भरपाई नोंद संपादित करा",
  ownerId: "मालक आयडी:",
  updateSuccess: "भरपाई नोंद यशस्वीरित्या अद्यतनित झाली!",
  currentRecordInfo: "सध्याची नोंद माहिती",
  totalLand: "एकूण जमीन",
  acquireLand: "जमीन अधिग्रहित करा",
  landPrimaryAssets: "जमीन आणि प्राथमिक मालमत्ता",
  landCompensationAmount: "जमिनीची भरपाई रक्कम",
  totalLandArea: "एकूण जमीन क्षेत्रफळ",
  acquiredLandArea: "अधिग्रहित जमीन क्षेत्रफळ",
  rate: "दर",
  amount: "रक्कम",
  autoCalculatedAmount: "ही रक्कम वरील फील्डमधून स्वयंचलितपणे गणना केली गेली आहे",
  secondaryAssets: "दुय्यम मालमत्ता",
  compensationCalculations: "भरपाई गणना",
  additionalAmount: "अतिरिक्त रक्कम",
  reasonAdditionalComp: "अतिरिक्त भरपाईचे कारण",
  interestCalculation: "व्याज गणना (दिनांक आधारित)",
  interestPeriodDays: "व्याज कालावधी (दिवस)",
  autoInterestCalc: "दिनांक श्रेणीतून स्वयंचलितपणे गणना",
  interestFromDate: "व्याज प्रारंभ तारीख",
  interestToDate: "व्याज समाप्त तारीख",
  calculatedInterestAmount: "गणना केलेली व्याज रक्कम",
  calcDetails: "गणना तपशील:",
  interestPerAnnum: "दरवर्षी",
  timePeriod: "कालावधी",
  years: "वर्षे",
  from: "पासून",
  liveCalcPreview: "थेट गणना पूर्वदृश्य",
  baseAmount: "मूलभूत रक्कम",
  interest: "12% व्याज",
  additional: "अतिरिक्त",
  adminDetails: "प्रशासनिक तपशील",
  compStatus: "भरपाई स्थिती",
  updateSuccessShort: "यशस्वीरित्या अद्यतनित केले",
  updateCompensation: "भरपाई अद्यतनित करा",
  downloadCSV: "CSV डाउनलोड",
  sendToLao: "LAO ला पाठवा",
  proceedWarning: "आपण पुढे जाणार आहात",
  continueWarning: "आपण खरोखरच पुढे जायचे आहे का? काही सर्वेक्षणांचे अद्याप सत्यापन बाकी आहे.",
  RateAndAmountDisabled: "संख्या उपलब्ध नसल्यामुळे दर आणि रक्कम अक्षम आहे",
  RecordedValuePartialRate: "वहिती योग्य + पोट खराब जमीनीचा प्र. हे.दर रु.",
  RecordedValuePartialMarket: "वहिती योग्य + पोट खराब जमीनीचे बाजारमुल्य",
  MarketValueDoubleFactor: "जमिनीचे बाजारमूल्य x 2 गुणक (रकाना क्र. 8 वर)",
  TreeValuation: "फळझाडांचे मुल्यांकन",
  ConstructionValue: "बांधकाम किंमत",
  WellBorewell: "विहीर बोअर वेल",
  ForestTreeValuation: "वनझाडांचे मुल्यांकन",
  StructureValuation: "संरचना मूल्यांकन",
  TotalAmount: "एकूण रक्कम (रकाना क्र.9+10+11+12)",
  TotalSecondAmount: "एकूण रक्कम (रकाना क्र.13+14+15+16)",
  ReliefAmount100: "100% दिलासा रक्कम (रकाना क्र.13 वर)",
  InterestAmountFrom: "व्याज रक्कम पासून",
  AdvanceCompDeduction: "आगाऊ भरपाई कपात",
  AdvanceInterestDeduction: "आगाऊ व्याज कपात",
  NetPayableAmount: "निव्वळ देय रक्कम (रकाना 17-(19-20)",
  RecordedAreaIrrigable: "वहिती क्षेत्र",
  NonIrrigable: "पोख",
  TotalAquare: "एकूण",
  LandToBeAcquire: "अधिग्रहित करावयाची जमीन",
  Days: "दिवस",
  CountIsAvailable: "संख्या उपलब्ध आहे",
  RateAndAmountDisabledBecauseNo: "दर आणि रक्कम अक्षम आहेत कारण काहीही नाही",
  PleaseCompleteAllRecordsBeforeSendingToFinalAward: "कृपया अंतिम पुरस्कारासाठी पाठवण्यापूर्वी सर्व नोंदी पूर्ण करा.",
  SuccessfullySentToFinalAwards: "अंतिम पुरस्कार यशस्वीरित्या पाठवले!",

  // FinalReward
  recordsSelected: "रेकॉर्ड निवडले",
  sendToKJP: "KJP कडे पाठवा",
  LandAcquisitionCerti: "भूसंपादन प्रमाणपत्र",
  finalVerdict: "अंतिम निर्णय",
  recordedValuePartialPurchaseRate: "नोंद मूल्य + अंशतः खरेदी जमीन दर प्रति हेक्टेअर",
  recordedValuePartialPurchaseMarketValue: "नोंद मूल्य + अंशतः खरेदी जमीन बाजारभाव",
  landMarketValueTwoFactor: "जमीन बाजारभाव × 2 गुणक (क्र.8 * 2 गुणक)",
  treeValuation: "झाडांचे मूल्यांकन",
  constructionValue: "बांधकाम मूल्य (घर + टिनशेड)",
  wellBorewell: "विहीर/बोअरवेल (पाणीसाठा + विहीर/बोअरवेल)",
  structureValuation: "संरचना मूल्यांकन",
  totalAmountSum9to13: "एकूण रक्कम (स्तंभ 9+10+11+12+13 ची बेरीज)",
  // reliefAmount100: "100% दिलासा रक्कम",
  interest12Percent: "12% अ.घ.रक्कम दि. 25-05-2018 ते 05-04-2023 पर्यंत (1776 दिवस)",
  // totalAmountSum14to17: "एकूण रक्कम (14+15+16+17)",
  advanceCompensation50: "50% आगाऊ भरपाई कपात",
  advanceInterest50: "50% आगाऊ व्याज कपात 05-04-2023 पर्यंत",
  // netPayableAmount: "देय रक्कम (18 - (19+20))",
  recordedAreaIrrigable: "नोंद क्षेत्र (सिंचनयोग्य)",
  poKhaNonIrrigable: "पो. खा (असिंचनयोग्य)",
  totalAquare: "एकूण (वर्गमीटर)",
  loadingCompensationRecords: "भरपाई रेकॉर्ड लोड होत आहेत...",
  tabaPavti: "ताबा पावती",
  downloadFinalVerdict: "अंतिम निर्णय अहवाल डाउनलोड करा",
  choosePreferredDownload: "आपला पसंतीचा डाउनलोड प्रकार निवडा:",
  confirmationPendingSurveys: "आपण खरोखर पुढे जाऊ इच्छिता? काही सर्व्हे अजून सत्यापित व्हायचे आहेत.",
  LoadingFinalAwardData: "अंतिम निवाडा डेटा लोड होत आहे...",


  // Payment
  paymentManagement: "पेमेंट व्यवस्थापन",
  selectFiltersToViewPayment: "पेमेंट डेटा पाहण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा.",
  compensationValue: "भरपाई रक्कम",
  updatePayment: "पेमेंट अद्यतनित करा",
  addCompensation: "भरपाई जोडा",
  selectFiltersToViewPaymentAlt: "पेमेंट डेटा पाहण्यासाठी वरील फिल्टर पॅनेलमधून जिल्हा, तालुका आणि गाव निवडा.",
  paymentDetails: "पेमेंट तपशील",
  paymentInformation: "पेमेंट माहिती",
  toBankDetails: "बँक तपशील (प्राप्तकर्ता)",
  fromBankDetails: "बँक तपशील (पाठवणारा)",
  NoPaymentRecordsFound: "कोणतेही देयक रेकॉर्ड सापडले नाहीत",
  PleaseSelectDistrictTalukaVillageToLoadPaymentData: "देयक डेटा लोड करण्यासाठी कृपया जिल्हा, तालुका आणि गाव निवडा",
  ProposalId: "प्रस्ताव आयडी",


  // KabjaPauti
  ownerSelected: "मालक निवडले",
  sendToPayment: "पेमेंटसाठी पाठवा",
  pleaseSelectLocation: "KJP डेटा पाहण्यासाठी जिल्हा, तालुका आणि गाव निवडा.",
  location: "स्थान",
  kjpStatus: "KJP स्थिती",
  loadingKjpRecords: "KJP नोंदी लोड होत आहेत...",
  kjp: "KJP",
  pendingKjp: "प्रलंबित KJP",
  pleaseSelectFromFilter: "KJP डेटा पाहण्यासाठी वरील फिल्टर पॅनेलमधून जिल्हा, तालुका आणि गाव निवडा.",
  compensationRecordDetails: "भरपाई नोंदींचा तपशील",
  SurveyNumber: "सर्व्हे क्र.",
  kjpInformation: "KJP माहिती",
  kjpNumber: "KJP क्रमांक",
  kjpDate: "KJP तारीख",
  kjpRemarks: "KJP टिप्पणी",
  kjpDocument: "KJP दस्तऐवज",
  recordSummary: "नोंदींचा सारांश",
  owner: "मालक",
  current: "चालू",
  saveKjpRecord: "KJP नोंद जतन करा",
  doYouReallyWantToContinue: "आपण खरोखरच पुढे जायचे आहे का? अजून काही सर्व्हे सत्यापित करायचे बाकी आहेत",
  KJPDocumentImage: "KJP दस्तऐवज/प्रतिमा",
  AddKJPRecord: "KJP नोंद जोडा",
  EditKJPRecord: "KJP नोंद संपादित करा",

  //Concern Valuer
  AgWirefencing: "तारकंपाउंड",
  AgFarmpond: "शेती तलाव",
  NoDataAvailableForThisRecord: "या नोंदीसाठी कोणताही डेटा उपलब्ध नाही",
  TPAgency: "टीपी संस्था",
  AgEdit: "संपादित करा",
  AgAction: "कृती",
  Numberofactuals: "प्रत्यक्ष संख्या",
  Compensationpayable: "देय मोबदला (मूल्यांकन अहवालानुसार)",
  Agtype: "प्रकार",
  Typesoffruittrees: "फळझाडे प्रकार",
  Foresttype: "वनझाडे प्रकार",
  Numericalcount: "संयूक्तमोजणीनुसार संख्या",
  AgSurveyGatNo: "गट/सर्व्हे क्रमांक",
  Compositenumber: "संयूक्तमोजणी संख्या",
  Paymentdue: "देय मोबदला",
  PropertyDescription: "मालमत्तेचे वर्णन",
  Areaaccordingtojointcalculation: "संयुक्त मोजणी अनुसार क्षेत्रफळ",
  Yearofconstruction: "बांधकाम वर्ष ",
  actualarea: "प्रत्यक्ष क्षेत्रफल",
  Agother: "इतर",
  Areacalculation: "संयुक्त मोजणी अनुसार",
  Aga: "प्रत्यक्ष",
  Aghome: "घर (क्षेत्रफल)",
  Agpipeline: "पाईपलाईन (लांबी)",
  Agborewell: "बोअरवेल (लांबी)",
  Agarea: "क्षेत्रफल",
  Areaaccordingtocombinedcalculation: "संयुक्तमोजणीनुसार क्षेत्रफळ",
  Agactualarea: "प्रत्यक्षातील क्षेत्रफळ",
  Lengthaccordingtojointmeasurement: " संयुक्तमोजणीनुसार लांबी",
  actuallength: "प्रत्यक्ष लांबी",
  Agmeter: "मीटर",
  Agsquaremeter: "चौरस मीटर",
  Agcactualarea: "प्रत्यक्षातील क्षेत्रफळ",
  Cubicmeter: "घन मीटर",
  Depthasperjointmeasurement: "संयुक्तमोजणीनुसार खोली",
  Volumeasperjointmeasurement: "संयुक्तमोजणीनुसार घनफळ",
  ActualVolume: "प्रत्यक्षातील घनफळ",

  Borewelldepth: "बोअरवेल (खोली)",
  Pipelinelength: "पाईपलाईन (लांबी)",
  Homearea: "घर (क्षेत्रफळ)",
  TinShedarea: "टिन शेड (क्षेत्रफळ)",
  Wirefencingarea: "Wirefencing (क्षेत्रफळ)",
  Wellvolume: "विहीर (घनफळ)",
  Farmpondvolume: "शेती तलाव (घनफळ)",
  OtherAssetarea: "इतर मालमत्ता (क्षेत्रफळ)",

  //Common
  CommonSave: "पाठवा",
  DrawSignatureArea: "स्वाक्षरी क्षेत्रे काढा",
  SignNote: "स्वाक्षरी बॉक्स तयार करण्यासाठी क्लिक करा आणि ड्रॅग करा. तुम्ही कोणत्याही पृष्ठावर अनेक स्वाक्षऱ्या जोडू शकता.",
  AddSignature: "स्वाक्षरी जोडा",
  ConfirmAllSignature: "सर्व स्वाक्षऱ्यांची पुष्टी करा",

  //JMR
  editpropertyoccupant: "भूसंलग्न मालमात्ताची माहिती भरा",
  Joverview: "गोषवारा",
  Jtree: "झाडे",
  Jhouse: "बांधकाम",
  Jtinshed: "टीन शेड",
  Jwire: "तार कुंपण",
  Jfarmpond: "शेततळे",
  Jwells: "विहीर",
  Jborewells: "बोअरवेल",
  Jpipeline: "पाईपलाइन",
  Jothers: "ईतर",
  Jlocation: "ठिकाण / मीडीया फाइल्स",
  Jremark: "शेरा",
  propertyoverview: "मालमत्ता तपशील",
  areasatbar: "गाव नमुना नं ७/१२ नुसार क्षेत्र",
  culti: "लागवडयोग्य",
  nonculti: "पोटखराब",
  Jtotal: "एकूण",
  areaJMR: "संयुक्त मोजणीनुसार क्षेत्र",
  JoccupantInformation: "कब्जेदार/भूधाराक माहिती",
  natureofacquisition: "मालमत्ता कब्जात असण्याचे कायदेशीर कारण",
  number: "मोबाईल नंबर",
  Jaddress: "पत्ता",
  AssetsSummary: "मालमत्ता सारांश",

  treemanagement: "झाडांची माहिती भरा",
  addTree: "झाड जोडा",
  notreeadded: "अजून झाडे जोडलेली नाहीत",
  Jselectcategory: "प्रकार निवडा",
  treetype: "नाव",
  Jselecttreetype: "नाव निवडा",
  captureimage: "फोटो काढा",
  Jview: "पहा",

  homesManagement: "बांधकाम माहिती",
  addhome: "बांधकाम जोडा",
  nohomeadded: "अद्याप कोणतीही बांधकाम जोडलेले नाही",
  constructionType: "बांधकाम प्रकार",
  floortype: "मजला",
  length: "लांबी (मी)",
  width: "रुंदी (मी)",
  height: "उंची (मी)",
  selectfloor: "मजला निवडा",
  groundfloor: "तळमजला",
  ffloor: "१ला मजला",
  sfloor: "२रा मजला",

  //Form Sheel
  formSell: 'फॉर्म सी',

  kalam37_2: 'कलम 37(2)',

  //Tehsildar
  SendToTehsilar: 'भूमिअभिलेख अध्यवतीकरण',
  punarSendToTehsilar: 'तेहसीलदार पाठवा',
  Tehsilar: 'भूमी अभिलेख अद्यावतीकरण',
  Section20ANotification: 'कलम २०अ अधिसूचना',

  //Land Beneficiary Letter
  landBeneficiaryLetter: 'जमीन लाभार्थी पत्र',
  objection: "अक्षेप",
  objectionReport: 'अक्षेप निराकरण प्रसिधी अहवाल',
  objectionComments: 'आक्षेप टिप्पणी',


  //Family Survey No
  FamilySurveyForm: 'कौटुंबिक सर्वेक्षण फॉर्म',

  //Work Assign
  WorkAssign: 'कार्य नियुक्त करा',
  assignToSurveyor: "भुकरमापक नियुक्त करा",
  OtherDocuments: "इतर प्रमाणपत्र",
  AllDocuments: "सर्व कागदपत्रे",

  //FundRequestReceived
  FundRequestReceived: "निधीची विनंती",
  FundRequestDate: "निधी मागणी दिनांक",
  FundRequest: "निधी मागणी",
  ReceiveFundDate: "निधी प्राप्त दिनांक",
  ReciveFund: "प्राप्त निधी",
  ChequeAmount: "जनादेश क्रमांक",
  ChequeDate: "जनादेश दिनांक",
  ReceiveAmount: "प्राप्त रक्कम",
  Section19heading: "निधी मागणी-कलम 19",
  FinalAwardheading: "निधी मागणी-अंतिमनिवाडा",
  SelectUserProjectIncharge: "प्रोजेक्ट इंचेजला पाठवा",
  SendToProjectIncharge11: "प्रोजेक्ट इन्चार्जकडे पाठवा कलम 11",
  SendToProjectIncharge19: "प्रोजेक्ट इन्चार्जकडे पाठवा कलम 19",
  RequestedFund: "विनंती केलेला निधी",
  //ExtendedDate
  ExtendedDate: "दिनांक वाढवणे",
  ExtendedDate11: " कलम 19 ची घोषणा करीता मुदत वाढवणे",
  ExtendedDate19: " अंतिम निवाडा ची घोषणा करीता मुदत वाढवणे",
  Section19Date: "कलम 19 तारीख",
  Setion19PublicationDate: "कलम 19 प्रसिद्धी तारीख",
  Section19OneYearDate: "कलम 19 व्यपगत दिनांक",

  namunaA: "नमुना अ",
  namunaB: "नमुना ब",
  namunaK: "नमुना क",

  landAllocationReport: "भूखंडाचा तपशील",
  kalam11: "कलम ११(१)",
  landBeneficiaryList: "भूखंड वाटपाची प्रारूप यादी",
  landFormatList: "प्रारूप यादी",
  landRemarks: "प्रारूप टिप्पणी",
  landFinalRemarks: "अंतिम टिप्पणी ",
  landFinalReport: "अंतिम अहवाल",
  landBeneficiaryReport: "प्रारूप अहवाल",
  landObjectionRegister: "आक्षेप नोंदणी",
  finalLandAllotmentList: "भूखंड वाटपाची अंतिम यादी",
  finalLandAllotmentLetter: "अंतिम जमीन वाटप पत्रे",
  tabaPautiTippaniLetters: "तबा पावती टिपणी अक्षरे",
  tabaPautiPunarvarshan: "तबा पावती ",
  PlotAllotmentLetter: "भूखंडवाटपाची चिट्ठी",
  //send to DRO
  SuccessfullySentToDRO: "डीआरओकडे यशस्वीरित्या पाठवले!",
  selectUserDROOfficer: "वापरकर्ता निवडा (डीआरओ अधिकारी)",
  searchRecords: "रेकॉर्ड शोधा",

  //Railway
  section20A: "कलम २०अ",
  section20B: "कलम २०बी",
  section20D: "कलम २०डी",
  section20E: "कलम २०ई",
  section20F: "कलम २०एफ",
  section20G: "कलम २०जी",
  section20I: "कलम २०आई",
  section20F_6: "कलम २०एफ(६)",
  appealLies: "अपील करता येते",

  //RailwayProposal
  railwayProposal: "रेल्वे प्रस्ताव",
  createRailwayProposal: "रेल्वे प्रस्ताव तयार करा",
  editRailwayProposal: "रेल्वे प्रस्ताव संपादित करा",
  viewRailwayProposal: "रेल्वे प्रस्ताव पहा",
  railwayLandHoldingList: "रेल्वे जमीनधारकांची यादी",
  namuna_Kh: "नमुना ख",
  docu7_12: "सात-बारा",
  eight_A: "आठ-अ",
  villageMap: "गाव नकाशा",
  creditorList: "अल्प - भुधारक यादी",
  privateLandForm1: "प्रपत्र -१",
  privateLandForm2: "प्रपत्र -२",
  acquisitionBoundaryAndArea: "चर्तुः सिमा",

  introduction: "प्रस्तावना",
  // parishtisht_A: "परिशिष्ट ए",
  Parishtisht_ASubmissionLetter: "परिशिष्ट 'अ'",
  annexure_E: "परिशिष्ट ई",

  railwayFundRequest: "रेल्वे निधीची विनंत",
  railwayJointMesurmentList: "(२०ब) संयुक्त मोजमाप यादी",
  railwayAdvancePayment: "रेल्वे आगाऊ पेमेंट",
  railwayObjectionList: "(२०दि) हरकती यादी",
  railwayExtendedDate: "रेल्वे वाढवलेली तारीख",
  railwaySection19: "(२० ई)कलम 19",
  railwaySection21: "रेल्वे कलम 21",
  railwayMarketValue: "रेल्वे बाजारमूल्य",
  railwaySection93: "रेल्वे कलम 93",
  railwayExtendedDate19: "रेल्वे वाढवलेली तारीख कलम 19",
  railwaySelectFormat: "20(फ) प्रारूप निवडा",
  railwayFinalReward: "20(ग्रॅम) अंतिम निवाडा",
  railwayWorkersJudgment: "20(इ) ताबा पावती ",
  railwayPayment: "रेल्वे पेमेंट",
  railwayPAP: "रेल्वे PAP",
  railwayPunavarshan: "रेल्वे पुनर्विकास",
  railwaySearchBar: "रेल्वे शोध बार",
  railwayPublishProposal: "(२०अ) प्रस्ताव प्रकाशित करा",

  //Highway

  section3A: "कलम ३अ",
  section3A_Eng: "कलम 3A",
  cala: "सक्षम प्राधिकारी (काला कलम 3a) ",
  highwayFundRequestReceived: "निधीची विनंती",
  section3B: "कलम ३बी",
  section3C: "कलम ३सी",
  section3D: "कलम ३डी",
  section3G: "कलम ३जी",
  section3H: "कलम ३एच",
  tabaPauti: "ताबा पौती",
  highwayAddLand: "जोडा जमीन-धारणा",
  highwayPublishProposal: "विभाग ११",

  //HighwayProposal
  highwayProposal: "प्रस्ताव",
  createHighwayProposal: "प्रस्ताव तयार करा",
  editHighwayProposal: "प्रस्ताव संपादित करा",
  viewHighwayProposal: "प्रस्ताव पहा",

  //HighwayLandHolding
  highwayLandHoldingList: "भूमि स्वामित्व सूची",
  highwayJointMesurmentList: "3(B) संयुक्त मोजमाप यादी",
  highwayAdvancePayment: " आगाऊ पेमेंट",
  highwayExtendedDate11: " वाढवलेली तारीख कलम 11",
  highwayobjectionList: "3(C) हरकती यादी",
  highwayExtendedDate: " वाढवलेली तारीख",
  highwayCoveringLettersSection19: "3(D) कलम 19 मान्यता",
  highwayTehsildar: "3(D) कलम 19 ची घोषणा",
  highwaySection21: "जाहिरनामा",
  highwaySidebarSection21_1_4: "कलम 21_1_4 ची कार्यवाही",
  highwaySection21_1: "कलम 21(1)",
  highwaySection21_1_4: "कलम 21_1_4 ची कार्यवाही",
  highwayUnderSection21: "कलम २१नुसार दाखल दाव्यांचा तपशील",
  highwayReportLandAcquisition: "महामार्ग जमीन संपादन अहवाल",
  highwayAnusuchi1: "Highway Anusuchi 1",
  highwayAnusuchi2: "Highway Anusuchi 2",
  highwayAnusuchi3: "Highway Anusuchi 3",
  highwayAnusuchi4: "Highway Anusuchi 4",
  highwayAnusuchi5: "Highway Anusuchi 5",
  highwayAnusuchi6: "Highway Anusuchi 6",
  highwayAnusuchi7: "Highway Anusuchi 7",
  highwayOtherDocuments: "Highway Other Documents",

  highwayMarketValue: "जमिनीचे बाजारमूल्य",
  highwayMarketValueBail: "जमिनीचे बाजारमूल्य निश्चिती",
  highwayDirectPurchase: "खरेदी विक्री तक्ता",
  highwayConcernValuer: "संबंधित मूल्यांकनकर्ता",
  highwaySection93: "कलम ९३",
  highwayExtendedDate19: "कलम अंतिम निवाडा ची घोषणा करीता मुदत वाढवणे",
  highwaySelectFormat: "3(G) प्रारूप निवडा",
  highwayfinalaward: "अंतिम निवाडा",
  highwayWorkersjudgment: "जमिनीचा ताबा",
  highwayPayment: "3(H) पेमेंट",
  highwayProjectAffectedPerson: "प्रकल्पग्रस्त व्यक्ती",
  highwayPunavarshan: "पुनर्वसन",
  highwaySearchBar: "शोध पट्टी",
  highwayTehsilar: "भूमी अभिलेख अद्यावतीकरण",


  BackToProjectIncharge: "यंत्रणाला परत पाठवा",
  Tehsilar:"तहसीलदार",
};

export default translations;